(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["0-0-mbc-upsell"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.mbc');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.mbcInit === '1') continue;
      el.dataset.mbcInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[mbc]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.mbc__plan-card');
    var qtyRows   = root.querySelectorAll('.mbc__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="mbc-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="mbc-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.mbc__qty-row[data-qty="2"] .mbc__qty-extra');

    function getActiveQtyRow(){
      return root.querySelector('.mbc__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.mbc__qty-now');
        var saveEl  = b.querySelector('.mbc__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
      }
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Subscription selected · Cancel anytime';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no subscription';
        }
      }
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // ==================================================================
    // IODINE UPSELL + AJAX CART
    //
    // A Shopify product form posts exactly ONE variant, so the moment a
    // second product is involved the submit has to go through /cart/add.js
    // with an items array. Every failure path below still ends in a real
    // add: a rejected request retries without the add-on, and if that also
    // fails it falls through to the native form post. A customer must never
    // click Add to Cart and end up with nothing in it.
    // ==================================================================
    var form    = root.querySelector('form[id^="mbc-form-"]');
    // 'button.mbc__cta', NOT '[id^="mbc-cta-"]' — the prefix selector also
    // matches mbc-cta-text-* and mbc-cta-sub-*, so it would return the label
    // span instead of the button and every disable/enable would silently no-op.
    var ctaBtn  = root.querySelector('button.mbc__cta');
    var upBox   = root.querySelector('[data-mbcup]');
    var upCb    = root.querySelector('[data-mbcup-toggle]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;

    function upsellWanted(){
      return !!(upBox && upCb && upCb.checked && !upBox.classList.contains('is-off'));
    }

    // Make declining VISIBLE. The card is pre-checked, so if the two states
    // look alike the customer cannot tell whether the add-on is in their
    // order — which reads as a dark pattern and costs the sale either way.
    // 'is-declined' is purely cosmetic; 'is-off' still means hidden.
    // The toggle itself is native (the whole card is the <label>), so this
    // listener only mirrors state — it never drives it.
    // Match the BOTTLE's height to the copy column beside it — top edge level
    // with the title's top, bottom edge level with the YOU SAVE badge's bottom.
    // Done in JS because CSS cannot derive one element's height from a
    // sibling's. The only pure-CSS route is stretching the copy column to the
    // image instead, which moves the text — not what was asked for. Nothing
    // here touches the copy's spacing; it only ever resizes the image.
    //
    // The CSS height is the no-JS fallback. It carries !important, so the
    // inline override MUST be set with priority or it silently loses.
    var upCopy = upBox && upBox.querySelector('.mbcup__copy');
    var upImg  = upBox && upBox.querySelector('.mbcup__media img');
    function syncUpsellMediaHeight(){
      if (!upCopy || !upImg) return;
      var h = upCopy.getBoundingClientRect().height;
      if (h <= 0) return;
      // Only write on a real change — guards against a ResizeObserver loop.
      if (Math.abs(parseFloat(upImg.style.height || '0') - h) < 0.5) return;
      upImg.style.setProperty('height', h + 'px', 'important');
    }
    if (upCopy && upImg){
      // Debounced with a self-clearing timeout, NOT a rAF guard flag.
      // A `if (pending) return;` gate around requestAnimationFrame deadlocks
      // permanently the moment one rAF callback fails to run — which happens
      // whenever the page is not considered visible (background tab, embedded
      // preview pane), because rAF is throttled there while timers still fire.
      // The flag then stays set and every future resize is silently dropped.
      // clearTimeout+reassign has no such trap: the latest call always wins.
      var upTimer = 0;
      function scheduleUpsellSync(){
        if (upTimer) clearTimeout(upTimer);
        upTimer = setTimeout(function(){
          upTimer = 0; syncUpsellMediaHeight();
        }, 40);
      }

      syncUpsellMediaHeight();

      // Bind resize ALWAYS — never treat ResizeObserver as sufficient.
      // Verified on this storefront: ResizeObserver exists but never fires,
      // not even the guaranteed initial callback, because a third-party
      // script has stubbed it. The old code only attached this listener when
      // ResizeObserver was ABSENT, so on this store nothing ever re-ran and
      // the bottle stayed frozen at its first-paint height while the copy
      // reflowed around it. Treat RO as a bonus, not the mechanism.
      window.addEventListener('resize', scheduleUpsellSync);
      window.addEventListener('orientationchange', scheduleUpsellSync);
      if (window.ResizeObserver){
        try { new ResizeObserver(scheduleUpsellSync).observe(upCopy); } catch (e) {}
      }

      // The webfont swap changes the copy's height after first paint.
      if (document.fonts && document.fonts.ready){
        document.fonts.ready.then(syncUpsellMediaHeight).catch(function(){});
      }
      // Late reflow catch-all: font swap, lazily-loaded media above the card,
      // and app scripts that inject content after load all move the copy.
      var upDelays = [120, 400, 1200, 2500];
      for (var d = 0; d < upDelays.length; d++) setTimeout(syncUpsellMediaHeight, upDelays[d]);

      // Event-independent backstop. Neither ResizeObserver nor the window
      // 'resize' event can be relied on here: RO is stubbed by a third-party
      // script on this storefront, and some embedded/preview viewports change
      // width without emitting 'resize' at all. Both were verified dead on
      // this page. So poll briefly and cheaply instead of trusting either.
      // syncUpsellMediaHeight early-returns when already within 0.5px, so a
      // steady-state tick is one getBoundingClientRect and nothing else.
      // Self-terminating: 30 ticks x 500ms = 15s, which comfortably covers
      // font swap, lazy media above the card, and late app injection. After
      // that the resize listener handles real user resizes in a real browser.
      var upPolls = 0;
      var upPoll = setInterval(function(){
        syncUpsellMediaHeight();
        if (++upPolls >= 30) clearInterval(upPoll);
      }, 500);
    }

    function syncUpsellState(){
      if (!upBox || !upCb) return;
      upBox.classList.toggle('is-declined', !upCb.checked);
    }
    if (upCb){
      upCb.addEventListener('change', syncUpsellState);
      syncUpsellState();
    }

    function openCartDrawer(){
      // Verified against the live AJ storefront: UpCart V2 exposes
      // upcartRefreshCart and upcartOpenCart as TOP-LEVEL window functions,
      // not as methods on window.upcart. Refresh before opening or the drawer
      // paints its preloaded snapshot and the lines we just added are missing.
      try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
      try {
        if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
        else if (window.upcart && typeof window.upcart.openCart === 'function') window.upcart.openCart();
      } catch (e) {}
      // Theme-native fallbacks, for any theme where UpCart is absent.
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
        document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
      } catch (e) {}
      var trigger = document.querySelector('#upcart-cart-trigger,.upcart-trigger,[data-upcart-open]');
      if (trigger){ try { trigger.click(); } catch (e) {} }
      var dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && typeof dawnDrawer.open === 'function'){ try { dawnDrawer.open(); } catch (e) {} }

      // Verify, then fall back. No drawer after ~1s means there is no drawer.
      setTimeout(function(){
        var opened = document.body.classList.contains('upcartPopupShow') ||
                     document.body.classList.contains('upcart-open') ||
                     !!document.querySelector('cart-drawer.active, .drawer.active, #CartDrawer.active');
        if (!opened) window.location.href = '/cart';
      }, 1000);
    }

    function postItems(items){
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: items})
      }).then(function(r){
        if (!r.ok){
          return r.json().catch(function(){ return {}; }).then(function(b){
            var err = new Error('cart/add failed');
            err.status = r.status;
            err.body = b;
            throw err;
          });
        }
        return r.json();
      });
    }

    // Tell UpCart to keep its hands off this buy box.
    //
    // upcartShouldSkipAddToCart is UpCart's own documented opt-out hook
    // (it ships as `e => false`). CHAIN it rather than replace it: anything
    // originating inside a .mbc section is ours to handle, everything else
    // falls through to whatever UpCart or another section already installed,
    // so no other add-to-cart on the page changes behaviour. Installed once
    // per page, not once per section. This is the belt to the type="button"
    // braces above — either alone is sufficient.
    if (!window.__mbcUpcartHooked){
      window.__mbcUpcartHooked = true;
      var priorSkip = window.upcartShouldSkipAddToCart;
      window.upcartShouldSkipAddToCart = function(ev){
        try {
          var t = ev && (ev.target || ev.srcElement);
          if (t && t.closest && t.closest('.mbc')) return true;
        } catch (e) {}
        try { return typeof priorSkip === 'function' ? priorSkip(ev) : false; }
        catch (e) { return false; }
      };
    }

    // The add itself. Shared by the CTA click and the Enter-key guard.
    function doAddToCart(){
      // No fetch = ancient browser. form.submit() is a real browser POST and
      // fires no submit listeners, so nothing can intercept it either.
      if (typeof window.fetch !== 'function'){ if (form) form.submit(); return; }

      var mainId = idInput && idInput.value;
      if (!mainId){ if (form) form.submit(); return; }

      var mainItem = {id: parseInt(mainId, 10), quantity: qty};
      if (planInput && planInput.value) mainItem.selling_plan = planInput.value;

      var items = [mainItem];
      var addOn = null;
      if (upsellWanted()){
        var upId = parseInt(upBox.getAttribute('data-mbcup-variant'), 10);
        if (upId){
          addOn = {id: upId, quantity: 1};
          // Attribution rides ON the add-on line, never on the cart. It therefore
          // survives exactly as long as the line does: rejected on add, or removed
          // in the drawer, means no property and so no order tag. Hidden from the
          // customer by the leading underscore; still readable by Flow and the API.
          var upSrc = (upBox.getAttribute('data-mbcup-source') || '').trim();
          if (upSrc){ addOn.properties = {'_upsell_source': upSrc}; }
          items.push(addOn);
        }
      }

      if (ctaBtn){ ctaBtn.disabled = true; ctaBtn.style.opacity = '.72'; }
      function release(){ if (ctaBtn){ ctaBtn.disabled = false; ctaBtn.style.opacity = ''; } }

      postItems(items)
        .then(function(){ release(); openCartDrawer(); })
        .catch(function(){
          // The add-on is the fragile line: it is Locksmith-locked and it is
          // oversold. Never let it take the main product down with it.
          if (!addOn){ release(); if (form) form.submit(); return; }
          postItems([mainItem])
            .then(function(){
              release();
              if (upCb) upCb.checked = false;
              openCartDrawer();
            })
            .catch(function(){ release(); if (form) form.submit(); });
        });
    }

    if (ctaBtn){
      ctaBtn.addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        doAddToCart();
      });
    }

    // Enter inside the form still raises a submit even with no submit button.
    // Catch it in the CAPTURE phase so we beat any cart app listening on bubble.
    if (form){
      form.addEventListener('submit', function(ev){
        ev.preventDefault();
        ev.stopImmediatePropagation();
        doAddToCart();
      }, true);
    }

    // Gallery
    var mainBox = root.querySelector('.mbc__main');
    var main = root.querySelector('.mbc__main img');
    var countEl = root.querySelector('[id^="mbc-count-"]');
    var thumbsContainer = root.querySelector('.mbc__thumbs');
    var thumbs = root.querySelectorAll('.mbc__thumb');
    var prev = root.querySelector('[id^="mbc-prev-"]');
    var next = root.querySelector('[id^="mbc-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src){
        // Re-point the intrinsic ratio BEFORE swapping src, so the box resizes
        // in one step instead of holding the previous image's height until the
        // new one decodes. Keeps every image at its true shape, uncropped.
        var tw = thumbs[idx].dataset.w, th = thumbs[idx].dataset.h;
        if (tw && th){ main.setAttribute('width', tw); main.setAttribute('height', th); }
        main.src = src;
      }
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._mbcDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._mbcDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._mbcDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._mbcDragged = false; }, 100);
        } else {
          thumbsContainer._mbcDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._mbcDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["0-0-upsell-test"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows   = root.querySelectorAll('.bbx__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="bbx-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bbx-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.bbx__qty-row[data-qty="2"] .bbx__qty-extra');

    function getActiveQtyRow(){
      return root.querySelector('.bbx__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bbx__qty-now');
        var saveEl  = b.querySelector('.bbx__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
      }
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Subscription selected · Cancel anytime';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no subscription';
        }
      }
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // ==================================================================
    // IODINE UPSELL + AJAX CART
    //
    // A Shopify product form posts exactly ONE variant, so the moment a
    // second product is involved the submit has to go through /cart/add.js
    // with an items array. Every failure path below still ends in a real
    // add: a rejected request retries without the add-on, and if that also
    // fails it falls through to the native form post. A customer must never
    // click Add to Cart and end up with nothing in it.
    // ==================================================================
    var form    = root.querySelector('form[id^="bbx-form-"]');
    // 'button.bbx__cta', NOT '[id^="bbx-cta-"]' — the prefix selector also
    // matches bbx-cta-text-* and bbx-cta-sub-*, so it would return the label
    // span instead of the button and every disable/enable would silently no-op.
    var ctaBtn  = root.querySelector('button.bbx__cta');
    var upBox   = root.querySelector('[data-bbxup]');
    var upCb    = root.querySelector('[data-bbxup-toggle]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;

    function upsellWanted(){
      return !!(upBox && upCb && upCb.checked && !upBox.classList.contains('is-off'));
    }

    // Make declining VISIBLE. The card is pre-checked, so if the two states
    // look alike the customer cannot tell whether the add-on is in their
    // order — which reads as a dark pattern and costs the sale either way.
    // 'is-declined' is purely cosmetic; 'is-off' still means hidden.
    // The toggle itself is native (the whole card is the <label>), so this
    // listener only mirrors state — it never drives it.
    // Match the BOTTLE's height to the copy column beside it — top edge level
    // with the title's top, bottom edge level with the YOU SAVE badge's bottom.
    // Done in JS because CSS cannot derive one element's height from a
    // sibling's. The only pure-CSS route is stretching the copy column to the
    // image instead, which moves the text — not what was asked for. Nothing
    // here touches the copy's spacing; it only ever resizes the image.
    //
    // The CSS height is the no-JS fallback. It carries !important, so the
    // inline override MUST be set with priority or it silently loses.
    var upCopy = upBox && upBox.querySelector('.bbxup__copy');
    var upImg  = upBox && upBox.querySelector('.bbxup__media img');
    function syncUpsellMediaHeight(){
      if (!upCopy || !upImg) return;
      var h = upCopy.getBoundingClientRect().height;
      if (h <= 0) return;
      // Only write on a real change — guards against a ResizeObserver loop.
      if (Math.abs(parseFloat(upImg.style.height || '0') - h) < 0.5) return;
      upImg.style.setProperty('height', h + 'px', 'important');
    }
    if (upCopy && upImg){
      // Debounced with a self-clearing timeout, NOT a rAF guard flag.
      // A `if (pending) return;` gate around requestAnimationFrame deadlocks
      // permanently the moment one rAF callback fails to run — which happens
      // whenever the page is not considered visible (background tab, embedded
      // preview pane), because rAF is throttled there while timers still fire.
      // The flag then stays set and every future resize is silently dropped.
      // clearTimeout+reassign has no such trap: the latest call always wins.
      var upTimer = 0;
      function scheduleUpsellSync(){
        if (upTimer) clearTimeout(upTimer);
        upTimer = setTimeout(function(){
          upTimer = 0; syncUpsellMediaHeight();
        }, 40);
      }

      syncUpsellMediaHeight();

      // Bind resize ALWAYS — never treat ResizeObserver as sufficient.
      // Verified on this storefront: ResizeObserver exists but never fires,
      // not even the guaranteed initial callback, because a third-party
      // script has stubbed it. The old code only attached this listener when
      // ResizeObserver was ABSENT, so on this store nothing ever re-ran and
      // the bottle stayed frozen at its first-paint height while the copy
      // reflowed around it. Treat RO as a bonus, not the mechanism.
      window.addEventListener('resize', scheduleUpsellSync);
      window.addEventListener('orientationchange', scheduleUpsellSync);
      if (window.ResizeObserver){
        try { new ResizeObserver(scheduleUpsellSync).observe(upCopy); } catch (e) {}
      }

      // The webfont swap changes the copy's height after first paint.
      if (document.fonts && document.fonts.ready){
        document.fonts.ready.then(syncUpsellMediaHeight).catch(function(){});
      }
      // Late reflow catch-all: font swap, lazily-loaded media above the card,
      // and app scripts that inject content after load all move the copy.
      var upDelays = [120, 400, 1200, 2500];
      for (var d = 0; d < upDelays.length; d++) setTimeout(syncUpsellMediaHeight, upDelays[d]);

      // Event-independent backstop. Neither ResizeObserver nor the window
      // 'resize' event can be relied on here: RO is stubbed by a third-party
      // script on this storefront, and some embedded/preview viewports change
      // width without emitting 'resize' at all. Both were verified dead on
      // this page. So poll briefly and cheaply instead of trusting either.
      // syncUpsellMediaHeight early-returns when already within 0.5px, so a
      // steady-state tick is one getBoundingClientRect and nothing else.
      // Self-terminating: 30 ticks x 500ms = 15s, which comfortably covers
      // font swap, lazy media above the card, and late app injection. After
      // that the resize listener handles real user resizes in a real browser.
      var upPolls = 0;
      var upPoll = setInterval(function(){
        syncUpsellMediaHeight();
        if (++upPolls >= 30) clearInterval(upPoll);
      }, 500);
    }

    function syncUpsellState(){
      if (!upBox || !upCb) return;
      upBox.classList.toggle('is-declined', !upCb.checked);
    }
    if (upCb){
      upCb.addEventListener('change', syncUpsellState);
      syncUpsellState();
    }

    function openCartDrawer(){
      // Verified against the live AJ storefront: UpCart V2 exposes
      // upcartRefreshCart and upcartOpenCart as TOP-LEVEL window functions,
      // not as methods on window.upcart. Refresh before opening or the drawer
      // paints its preloaded snapshot and the lines we just added are missing.
      try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
      try {
        if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
        else if (window.upcart && typeof window.upcart.openCart === 'function') window.upcart.openCart();
      } catch (e) {}
      // Theme-native fallbacks, for any theme where UpCart is absent.
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
        document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
      } catch (e) {}
      var trigger = document.querySelector('#upcart-cart-trigger,.upcart-trigger,[data-upcart-open]');
      if (trigger){ try { trigger.click(); } catch (e) {} }
      var dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && typeof dawnDrawer.open === 'function'){ try { dawnDrawer.open(); } catch (e) {} }

      // Verify, then fall back. No drawer after ~1s means there is no drawer.
      setTimeout(function(){
        var opened = document.body.classList.contains('upcartPopupShow') ||
                     document.body.classList.contains('upcart-open') ||
                     !!document.querySelector('cart-drawer.active, .drawer.active, #CartDrawer.active');
        if (!opened) window.location.href = '/cart';
      }, 1000);
    }

    function postItems(items){
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: items})
      }).then(function(r){
        if (!r.ok){
          return r.json().catch(function(){ return {}; }).then(function(b){
            var err = new Error('cart/add failed');
            err.status = r.status;
            err.body = b;
            throw err;
          });
        }
        return r.json();
      });
    }

    // Tell UpCart to keep its hands off this buy box.
    //
    // upcartShouldSkipAddToCart is UpCart's own documented opt-out hook
    // (it ships as `e => false`). CHAIN it rather than replace it: anything
    // originating inside a .bbx section is ours to handle, everything else
    // falls through to whatever UpCart or another section already installed,
    // so no other add-to-cart on the page changes behaviour. Installed once
    // per page, not once per section. This is the belt to the type="button"
    // braces above — either alone is sufficient.
    if (!window.__bbxUpcartHooked){
      window.__bbxUpcartHooked = true;
      var priorSkip = window.upcartShouldSkipAddToCart;
      window.upcartShouldSkipAddToCart = function(ev){
        try {
          var t = ev && (ev.target || ev.srcElement);
          if (t && t.closest && t.closest('.bbx')) return true;
        } catch (e) {}
        try { return typeof priorSkip === 'function' ? priorSkip(ev) : false; }
        catch (e) { return false; }
      };
    }

    // The add itself. Shared by the CTA click and the Enter-key guard.
    function doAddToCart(){
      // No fetch = ancient browser. form.submit() is a real browser POST and
      // fires no submit listeners, so nothing can intercept it either.
      if (typeof window.fetch !== 'function'){ if (form) form.submit(); return; }

      var mainId = idInput && idInput.value;
      if (!mainId){ if (form) form.submit(); return; }

      var mainItem = {id: parseInt(mainId, 10), quantity: qty};
      if (planInput && planInput.value) mainItem.selling_plan = planInput.value;

      var items = [mainItem];
      var addOn = null;
      if (upsellWanted()){
        var upId = parseInt(upBox.getAttribute('data-bbxup-variant'), 10);
        if (upId){
          addOn = {id: upId, quantity: 1};
          // Attribution rides ON the add-on line, never on the cart. It therefore
          // survives exactly as long as the line does: rejected on add, or removed
          // in the drawer, means no property and so no order tag. Hidden from the
          // customer by the leading underscore; still readable by Flow and the API.
          var upSrc = (upBox.getAttribute('data-bbxup-source') || '').trim();
          if (upSrc){ addOn.properties = {'_upsell_source': upSrc}; }
          items.push(addOn);
        }
      }

      if (ctaBtn){ ctaBtn.disabled = true; ctaBtn.style.opacity = '.72'; }
      function release(){ if (ctaBtn){ ctaBtn.disabled = false; ctaBtn.style.opacity = ''; } }

      postItems(items)
        .then(function(){ release(); openCartDrawer(); })
        .catch(function(){
          // The add-on is the fragile line: it is Locksmith-locked and it is
          // oversold. Never let it take the main product down with it.
          if (!addOn){ release(); if (form) form.submit(); return; }
          postItems([mainItem])
            .then(function(){
              release();
              if (upCb) upCb.checked = false;
              openCartDrawer();
            })
            .catch(function(){ release(); if (form) form.submit(); });
        });
    }

    if (ctaBtn){
      ctaBtn.addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        doAddToCart();
      });
    }

    // Enter inside the form still raises a submit even with no submit button.
    // Catch it in the CAPTURE phase so we beat any cart app listening on bubble.
    if (form){
      form.addEventListener('submit', function(ev){
        ev.preventDefault();
        ev.stopImmediatePropagation();
        doAddToCart();
      }, true);
    }

    // Gallery
    var mainBox = root.querySelector('.bbx__main');
    var main = root.querySelector('.bbx__main img');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src){
        // Re-point the intrinsic ratio BEFORE swapping src, so the box resizes
        // in one step instead of holding the previous image's height until the
        // new one decodes. Keeps every image at its true shape, uncropped.
        var tw = thumbs[idx].dataset.w, th = thumbs[idx].dataset.h;
        if (tw && th){ main.setAttribute('width', tw); main.setAttribute('height', th); }
        main.src = src;
      }
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._bbxDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["00-00-bcd-upsell"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bcd');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bcdInit === '1') continue;
      el.dataset.bcdInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[bcd]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.bcd__plan-card');
    var qtyRows   = root.querySelectorAll('.bcd__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="bcd-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bcd-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.bcd__qty-row[data-qty="2"] .bcd__qty-extra');

    function getActiveQtyRow(){
      return root.querySelector('.bcd__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bcd__qty-now');
        var saveEl  = b.querySelector('.bcd__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
      }
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Subscription selected · Cancel anytime';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no subscription';
        }
      }
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // ==================================================================
    // IODINE UPSELL + AJAX CART
    //
    // A Shopify product form posts exactly ONE variant, so the moment a
    // second product is involved the submit has to go through /cart/add.js
    // with an items array. Every failure path below still ends in a real
    // add: a rejected request retries without the add-on, and if that also
    // fails it falls through to the native form post. A customer must never
    // click Add to Cart and end up with nothing in it.
    // ==================================================================
    var form    = root.querySelector('form[id^="bcd-form-"]');
    // 'button.bcd__cta', NOT '[id^="bcd-cta-"]' — the prefix selector also
    // matches bcd-cta-text-* and bcd-cta-sub-*, so it would return the label
    // span instead of the button and every disable/enable would silently no-op.
    var ctaBtn  = root.querySelector('button.bcd__cta');
    var upBox   = root.querySelector('[data-bcdup]');
    var upCb    = root.querySelector('[data-bcdup-toggle]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;

    function upsellWanted(){
      return !!(upBox && upCb && upCb.checked && !upBox.classList.contains('is-off'));
    }

    // Make declining VISIBLE. The card is pre-checked, so if the two states
    // look alike the customer cannot tell whether the add-on is in their
    // order — which reads as a dark pattern and costs the sale either way.
    // 'is-declined' is purely cosmetic; 'is-off' still means hidden.
    // The toggle itself is native (the whole card is the <label>), so this
    // listener only mirrors state — it never drives it.
    // Match the BOTTLE's height to the copy column beside it — top edge level
    // with the title's top, bottom edge level with the YOU SAVE badge's bottom.
    // Done in JS because CSS cannot derive one element's height from a
    // sibling's. The only pure-CSS route is stretching the copy column to the
    // image instead, which moves the text — not what was asked for. Nothing
    // here touches the copy's spacing; it only ever resizes the image.
    //
    // The CSS height is the no-JS fallback. It carries !important, so the
    // inline override MUST be set with priority or it silently loses.
    var upCopy = upBox && upBox.querySelector('.bcdup__copy');
    var upImg  = upBox && upBox.querySelector('.bcdup__media img');
    function syncUpsellMediaHeight(){
      if (!upCopy || !upImg) return;
      var h = upCopy.getBoundingClientRect().height;
      if (h <= 0) return;
      // Only write on a real change — guards against a ResizeObserver loop.
      if (Math.abs(parseFloat(upImg.style.height || '0') - h) < 0.5) return;
      upImg.style.setProperty('height', h + 'px', 'important');
    }
    if (upCopy && upImg){
      // Debounced with a self-clearing timeout, NOT a rAF guard flag.
      // A `if (pending) return;` gate around requestAnimationFrame deadlocks
      // permanently the moment one rAF callback fails to run — which happens
      // whenever the page is not considered visible (background tab, embedded
      // preview pane), because rAF is throttled there while timers still fire.
      // The flag then stays set and every future resize is silently dropped.
      // clearTimeout+reassign has no such trap: the latest call always wins.
      var upTimer = 0;
      function scheduleUpsellSync(){
        if (upTimer) clearTimeout(upTimer);
        upTimer = setTimeout(function(){
          upTimer = 0; syncUpsellMediaHeight();
        }, 40);
      }

      syncUpsellMediaHeight();

      // Bind resize ALWAYS — never treat ResizeObserver as sufficient.
      // Verified on this storefront: ResizeObserver exists but never fires,
      // not even the guaranteed initial callback, because a third-party
      // script has stubbed it. The old code only attached this listener when
      // ResizeObserver was ABSENT, so on this store nothing ever re-ran and
      // the bottle stayed frozen at its first-paint height while the copy
      // reflowed around it. Treat RO as a bonus, not the mechanism.
      window.addEventListener('resize', scheduleUpsellSync);
      window.addEventListener('orientationchange', scheduleUpsellSync);
      if (window.ResizeObserver){
        try { new ResizeObserver(scheduleUpsellSync).observe(upCopy); } catch (e) {}
      }

      // The webfont swap changes the copy's height after first paint.
      if (document.fonts && document.fonts.ready){
        document.fonts.ready.then(syncUpsellMediaHeight).catch(function(){});
      }
      // Late reflow catch-all: font swap, lazily-loaded media above the card,
      // and app scripts that inject content after load all move the copy.
      var upDelays = [120, 400, 1200, 2500];
      for (var d = 0; d < upDelays.length; d++) setTimeout(syncUpsellMediaHeight, upDelays[d]);

      // Event-independent backstop. Neither ResizeObserver nor the window
      // 'resize' event can be relied on here: RO is stubbed by a third-party
      // script on this storefront, and some embedded/preview viewports change
      // width without emitting 'resize' at all. Both were verified dead on
      // this page. So poll briefly and cheaply instead of trusting either.
      // syncUpsellMediaHeight early-returns when already within 0.5px, so a
      // steady-state tick is one getBoundingClientRect and nothing else.
      // Self-terminating: 30 ticks x 500ms = 15s, which comfortably covers
      // font swap, lazy media above the card, and late app injection. After
      // that the resize listener handles real user resizes in a real browser.
      var upPolls = 0;
      var upPoll = setInterval(function(){
        syncUpsellMediaHeight();
        if (++upPolls >= 30) clearInterval(upPoll);
      }, 500);
    }

    function syncUpsellState(){
      if (!upBox || !upCb) return;
      upBox.classList.toggle('is-declined', !upCb.checked);
    }
    if (upCb){
      upCb.addEventListener('change', syncUpsellState);
      syncUpsellState();
    }

    function openCartDrawer(){
      // Verified against the live AJ storefront: UpCart V2 exposes
      // upcartRefreshCart and upcartOpenCart as TOP-LEVEL window functions,
      // not as methods on window.upcart. Refresh before opening or the drawer
      // paints its preloaded snapshot and the lines we just added are missing.
      try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
      try {
        if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
        else if (window.upcart && typeof window.upcart.openCart === 'function') window.upcart.openCart();
      } catch (e) {}
      // Theme-native fallbacks, for any theme where UpCart is absent.
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
        document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
      } catch (e) {}
      var trigger = document.querySelector('#upcart-cart-trigger,.upcart-trigger,[data-upcart-open]');
      if (trigger){ try { trigger.click(); } catch (e) {} }
      var dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && typeof dawnDrawer.open === 'function'){ try { dawnDrawer.open(); } catch (e) {} }

      // Verify, then fall back. No drawer after ~1s means there is no drawer.
      setTimeout(function(){
        var opened = document.body.classList.contains('upcartPopupShow') ||
                     document.body.classList.contains('upcart-open') ||
                     !!document.querySelector('cart-drawer.active, .drawer.active, #CartDrawer.active');
        if (!opened) window.location.href = '/cart';
      }, 1000);
    }

    function postItems(items){
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: items})
      }).then(function(r){
        if (!r.ok){
          return r.json().catch(function(){ return {}; }).then(function(b){
            var err = new Error('cart/add failed');
            err.status = r.status;
            err.body = b;
            throw err;
          });
        }
        return r.json();
      });
    }

    // Tell UpCart to keep its hands off this buy box.
    //
    // upcartShouldSkipAddToCart is UpCart's own documented opt-out hook
    // (it ships as `e => false`). CHAIN it rather than replace it: anything
    // originating inside a .bcd section is ours to handle, everything else
    // falls through to whatever UpCart or another section already installed,
    // so no other add-to-cart on the page changes behaviour. Installed once
    // per page, not once per section. This is the belt to the type="button"
    // braces above — either alone is sufficient.
    if (!window.__bcdUpcartHooked){
      window.__bcdUpcartHooked = true;
      var priorSkip = window.upcartShouldSkipAddToCart;
      window.upcartShouldSkipAddToCart = function(ev){
        try {
          var t = ev && (ev.target || ev.srcElement);
          if (t && t.closest && t.closest('.bcd')) return true;
        } catch (e) {}
        try { return typeof priorSkip === 'function' ? priorSkip(ev) : false; }
        catch (e) { return false; }
      };
    }

    // The add itself. Shared by the CTA click and the Enter-key guard.
    function doAddToCart(){
      // No fetch = ancient browser. form.submit() is a real browser POST and
      // fires no submit listeners, so nothing can intercept it either.
      if (typeof window.fetch !== 'function'){ if (form) form.submit(); return; }

      var mainId = idInput && idInput.value;
      if (!mainId){ if (form) form.submit(); return; }

      var mainItem = {id: parseInt(mainId, 10), quantity: qty};
      if (planInput && planInput.value) mainItem.selling_plan = planInput.value;

      var items = [mainItem];
      var addOn = null;
      if (upsellWanted()){
        var upId = parseInt(upBox.getAttribute('data-bcdup-variant'), 10);
        if (upId){
          addOn = {id: upId, quantity: 1};
          // Attribution rides ON the add-on line, never on the cart. It therefore
          // survives exactly as long as the line does: rejected on add, or removed
          // in the drawer, means no property and so no order tag. Hidden from the
          // customer by the leading underscore; still readable by Flow and the API.
          var upSrc = (upBox.getAttribute('data-bcdup-source') || '').trim();
          if (upSrc){ addOn.properties = {'_upsell_source': upSrc}; }
          items.push(addOn);
        }
      }

      if (ctaBtn){ ctaBtn.disabled = true; ctaBtn.style.opacity = '.72'; }
      function release(){ if (ctaBtn){ ctaBtn.disabled = false; ctaBtn.style.opacity = ''; } }

      postItems(items)
        .then(function(){ release(); openCartDrawer(); })
        .catch(function(){
          // The add-on is the fragile line: it is Locksmith-locked and it is
          // oversold. Never let it take the main product down with it.
          if (!addOn){ release(); if (form) form.submit(); return; }
          postItems([mainItem])
            .then(function(){
              release();
              if (upCb) upCb.checked = false;
              openCartDrawer();
            })
            .catch(function(){ release(); if (form) form.submit(); });
        });
    }

    if (ctaBtn){
      ctaBtn.addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        doAddToCart();
      });
    }

    // Enter inside the form still raises a submit even with no submit button.
    // Catch it in the CAPTURE phase so we beat any cart app listening on bubble.
    if (form){
      form.addEventListener('submit', function(ev){
        ev.preventDefault();
        ev.stopImmediatePropagation();
        doAddToCart();
      }, true);
    }

    // Gallery
    var mainBox = root.querySelector('.bcd__main');
    var main = root.querySelector('.bcd__main img');
    var countEl = root.querySelector('[id^="bcd-count-"]');
    var thumbsContainer = root.querySelector('.bcd__thumbs');
    var thumbs = root.querySelectorAll('.bcd__thumb');
    var prev = root.querySelector('[id^="bcd-prev-"]');
    var next = root.querySelector('[id^="bcd-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src){
        // Re-point the intrinsic ratio BEFORE swapping src, so the box resizes
        // in one step instead of holding the previous image's height until the
        // new one decodes. Keeps every image at its true shape, uncropped.
        var tw = thumbs[idx].dataset.w, th = thumbs[idx].dataset.h;
        if (tw && th){ main.setAttribute('width', tw); main.setAttribute('height', th); }
        main.src = src;
      }
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bcdDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bcdDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._bcdDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._bcdDragged = false; }, 100);
        } else {
          thumbsContainer._bcdDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._bcdDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["00-00-cgm-upsell"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.cgm');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.cgmInit === '1') continue;
      el.dataset.cgmInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[cgm]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.cgm__plan-card');
    var qtyRows   = root.querySelectorAll('.cgm__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="cgm-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="cgm-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.cgm__qty-row[data-qty="2"] .cgm__qty-extra');

    function getActiveQtyRow(){
      return root.querySelector('.cgm__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.cgm__qty-now');
        var saveEl  = b.querySelector('.cgm__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
      }
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Subscription selected · Cancel anytime';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no subscription';
        }
      }
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // ==================================================================
    // IODINE UPSELL + AJAX CART
    //
    // A Shopify product form posts exactly ONE variant, so the moment a
    // second product is involved the submit has to go through /cart/add.js
    // with an items array. Every failure path below still ends in a real
    // add: a rejected request retries without the add-on, and if that also
    // fails it falls through to the native form post. A customer must never
    // click Add to Cart and end up with nothing in it.
    // ==================================================================
    var form    = root.querySelector('form[id^="cgm-form-"]');
    // 'button.cgm__cta', NOT '[id^="cgm-cta-"]' — the prefix selector also
    // matches cgm-cta-text-* and cgm-cta-sub-*, so it would return the label
    // span instead of the button and every disable/enable would silently no-op.
    var ctaBtn  = root.querySelector('button.cgm__cta');
    var upBox   = root.querySelector('[data-cgmup]');
    var upCb    = root.querySelector('[data-cgmup-toggle]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;

    function upsellWanted(){
      return !!(upBox && upCb && upCb.checked && !upBox.classList.contains('is-off'));
    }

    // Make declining VISIBLE. The card is pre-checked, so if the two states
    // look alike the customer cannot tell whether the add-on is in their
    // order — which reads as a dark pattern and costs the sale either way.
    // 'is-declined' is purely cosmetic; 'is-off' still means hidden.
    // The toggle itself is native (the whole card is the <label>), so this
    // listener only mirrors state — it never drives it.
    // Match the BOTTLE's height to the copy column beside it — top edge level
    // with the title's top, bottom edge level with the YOU SAVE badge's bottom.
    // Done in JS because CSS cannot derive one element's height from a
    // sibling's. The only pure-CSS route is stretching the copy column to the
    // image instead, which moves the text — not what was asked for. Nothing
    // here touches the copy's spacing; it only ever resizes the image.
    //
    // The CSS height is the no-JS fallback. It carries !important, so the
    // inline override MUST be set with priority or it silently loses.
    var upCopy = upBox && upBox.querySelector('.cgmup__copy');
    var upImg  = upBox && upBox.querySelector('.cgmup__media img');
    function syncUpsellMediaHeight(){
      if (!upCopy || !upImg) return;
      var h = upCopy.getBoundingClientRect().height;
      if (h <= 0) return;
      // Only write on a real change — guards against a ResizeObserver loop.
      if (Math.abs(parseFloat(upImg.style.height || '0') - h) < 0.5) return;
      upImg.style.setProperty('height', h + 'px', 'important');
    }
    if (upCopy && upImg){
      // Debounced with a self-clearing timeout, NOT a rAF guard flag.
      // A `if (pending) return;` gate around requestAnimationFrame deadlocks
      // permanently the moment one rAF callback fails to run — which happens
      // whenever the page is not considered visible (background tab, embedded
      // preview pane), because rAF is throttled there while timers still fire.
      // The flag then stays set and every future resize is silently dropped.
      // clearTimeout+reassign has no such trap: the latest call always wins.
      var upTimer = 0;
      function scheduleUpsellSync(){
        if (upTimer) clearTimeout(upTimer);
        upTimer = setTimeout(function(){
          upTimer = 0; syncUpsellMediaHeight();
        }, 40);
      }

      syncUpsellMediaHeight();

      // Bind resize ALWAYS — never treat ResizeObserver as sufficient.
      // Verified on this storefront: ResizeObserver exists but never fires,
      // not even the guaranteed initial callback, because a third-party
      // script has stubbed it. The old code only attached this listener when
      // ResizeObserver was ABSENT, so on this store nothing ever re-ran and
      // the bottle stayed frozen at its first-paint height while the copy
      // reflowed around it. Treat RO as a bonus, not the mechanism.
      window.addEventListener('resize', scheduleUpsellSync);
      window.addEventListener('orientationchange', scheduleUpsellSync);
      if (window.ResizeObserver){
        try { new ResizeObserver(scheduleUpsellSync).observe(upCopy); } catch (e) {}
      }

      // The webfont swap changes the copy's height after first paint.
      if (document.fonts && document.fonts.ready){
        document.fonts.ready.then(syncUpsellMediaHeight).catch(function(){});
      }
      // Late reflow catch-all: font swap, lazily-loaded media above the card,
      // and app scripts that inject content after load all move the copy.
      var upDelays = [120, 400, 1200, 2500];
      for (var d = 0; d < upDelays.length; d++) setTimeout(syncUpsellMediaHeight, upDelays[d]);

      // Event-independent backstop. Neither ResizeObserver nor the window
      // 'resize' event can be relied on here: RO is stubbed by a third-party
      // script on this storefront, and some embedded/preview viewports change
      // width without emitting 'resize' at all. Both were verified dead on
      // this page. So poll briefly and cheaply instead of trusting either.
      // syncUpsellMediaHeight early-returns when already within 0.5px, so a
      // steady-state tick is one getBoundingClientRect and nothing else.
      // Self-terminating: 30 ticks x 500ms = 15s, which comfortably covers
      // font swap, lazy media above the card, and late app injection. After
      // that the resize listener handles real user resizes in a real browser.
      var upPolls = 0;
      var upPoll = setInterval(function(){
        syncUpsellMediaHeight();
        if (++upPolls >= 30) clearInterval(upPoll);
      }, 500);
    }

    function syncUpsellState(){
      if (!upBox || !upCb) return;
      upBox.classList.toggle('is-declined', !upCb.checked);
    }
    if (upCb){
      upCb.addEventListener('change', syncUpsellState);
      syncUpsellState();
    }

    function openCartDrawer(){
      // Verified against the live AJ storefront: UpCart V2 exposes
      // upcartRefreshCart and upcartOpenCart as TOP-LEVEL window functions,
      // not as methods on window.upcart. Refresh before opening or the drawer
      // paints its preloaded snapshot and the lines we just added are missing.
      try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
      try {
        if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
        else if (window.upcart && typeof window.upcart.openCart === 'function') window.upcart.openCart();
      } catch (e) {}
      // Theme-native fallbacks, for any theme where UpCart is absent.
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
        document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
      } catch (e) {}
      var trigger = document.querySelector('#upcart-cart-trigger,.upcart-trigger,[data-upcart-open]');
      if (trigger){ try { trigger.click(); } catch (e) {} }
      var dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && typeof dawnDrawer.open === 'function'){ try { dawnDrawer.open(); } catch (e) {} }

      // Verify, then fall back. No drawer after ~1s means there is no drawer.
      setTimeout(function(){
        var opened = document.body.classList.contains('upcartPopupShow') ||
                     document.body.classList.contains('upcart-open') ||
                     !!document.querySelector('cart-drawer.active, .drawer.active, #CartDrawer.active');
        if (!opened) window.location.href = '/cart';
      }, 1000);
    }

    function postItems(items){
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: items})
      }).then(function(r){
        if (!r.ok){
          return r.json().catch(function(){ return {}; }).then(function(b){
            var err = new Error('cart/add failed');
            err.status = r.status;
            err.body = b;
            throw err;
          });
        }
        return r.json();
      });
    }

    // Tell UpCart to keep its hands off this buy box.
    //
    // upcartShouldSkipAddToCart is UpCart's own documented opt-out hook
    // (it ships as `e => false`). CHAIN it rather than replace it: anything
    // originating inside a .cgm section is ours to handle, everything else
    // falls through to whatever UpCart or another section already installed,
    // so no other add-to-cart on the page changes behaviour. Installed once
    // per page, not once per section. This is the belt to the type="button"
    // braces above — either alone is sufficient.
    if (!window.__cgmUpcartHooked){
      window.__cgmUpcartHooked = true;
      var priorSkip = window.upcartShouldSkipAddToCart;
      window.upcartShouldSkipAddToCart = function(ev){
        try {
          var t = ev && (ev.target || ev.srcElement);
          if (t && t.closest && t.closest('.cgm')) return true;
        } catch (e) {}
        try { return typeof priorSkip === 'function' ? priorSkip(ev) : false; }
        catch (e) { return false; }
      };
    }

    // The add itself. Shared by the CTA click and the Enter-key guard.
    function doAddToCart(){
      // No fetch = ancient browser. form.submit() is a real browser POST and
      // fires no submit listeners, so nothing can intercept it either.
      if (typeof window.fetch !== 'function'){ if (form) form.submit(); return; }

      var mainId = idInput && idInput.value;
      if (!mainId){ if (form) form.submit(); return; }

      var mainItem = {id: parseInt(mainId, 10), quantity: qty};
      if (planInput && planInput.value) mainItem.selling_plan = planInput.value;

      var items = [mainItem];
      var addOn = null;
      if (upsellWanted()){
        var upId = parseInt(upBox.getAttribute('data-cgmup-variant'), 10);
        if (upId){
          addOn = {id: upId, quantity: 1};
          // Attribution rides ON the add-on line, never on the cart. It therefore
          // survives exactly as long as the line does: rejected on add, or removed
          // in the drawer, means no property and so no order tag. Hidden from the
          // customer by the leading underscore; still readable by Flow and the API.
          var upSrc = (upBox.getAttribute('data-cgmup-source') || '').trim();
          if (upSrc){ addOn.properties = {'_upsell_source': upSrc}; }
          items.push(addOn);
        }
      }

      if (ctaBtn){ ctaBtn.disabled = true; ctaBtn.style.opacity = '.72'; }
      function release(){ if (ctaBtn){ ctaBtn.disabled = false; ctaBtn.style.opacity = ''; } }

      postItems(items)
        .then(function(){ release(); openCartDrawer(); })
        .catch(function(){
          // The add-on is the fragile line: it is Locksmith-locked and it is
          // oversold. Never let it take the main product down with it.
          if (!addOn){ release(); if (form) form.submit(); return; }
          postItems([mainItem])
            .then(function(){
              release();
              if (upCb) upCb.checked = false;
              openCartDrawer();
            })
            .catch(function(){ release(); if (form) form.submit(); });
        });
    }

    if (ctaBtn){
      ctaBtn.addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        doAddToCart();
      });
    }

    // Enter inside the form still raises a submit even with no submit button.
    // Catch it in the CAPTURE phase so we beat any cart app listening on bubble.
    if (form){
      form.addEventListener('submit', function(ev){
        ev.preventDefault();
        ev.stopImmediatePropagation();
        doAddToCart();
      }, true);
    }

    // Gallery
    var mainBox = root.querySelector('.cgm__main');
    var main = root.querySelector('.cgm__main img');
    var countEl = root.querySelector('[id^="cgm-count-"]');
    var thumbsContainer = root.querySelector('.cgm__thumbs');
    var thumbs = root.querySelectorAll('.cgm__thumb');
    var prev = root.querySelector('[id^="cgm-prev-"]');
    var next = root.querySelector('[id^="cgm-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src){
        // Re-point the intrinsic ratio BEFORE swapping src, so the box resizes
        // in one step instead of holding the previous image's height until the
        // new one decodes. Keeps every image at its true shape, uncropped.
        var tw = thumbs[idx].dataset.w, th = thumbs[idx].dataset.h;
        if (tw && th){ main.setAttribute('width', tw); main.setAttribute('height', th); }
        main.src = src;
      }
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._cgmDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._cgmDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._cgmDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._cgmDragged = false; }, 100);
        } else {
          thumbsContainer._cgmDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._cgmDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["00-00-mbg-upsell"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.mbg');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.mbgInit === '1') continue;
      el.dataset.mbgInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[mbg]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.mbg__plan-card');
    var qtyRows   = root.querySelectorAll('.mbg__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="mbg-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="mbg-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.mbg__qty-row[data-qty="2"] .mbg__qty-extra');

    function getActiveQtyRow(){
      return root.querySelector('.mbg__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.mbg__qty-now');
        var saveEl  = b.querySelector('.mbg__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
      }
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Subscription selected · Cancel anytime';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no subscription';
        }
      }
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // ==================================================================
    // IODINE UPSELL + AJAX CART
    //
    // A Shopify product form posts exactly ONE variant, so the moment a
    // second product is involved the submit has to go through /cart/add.js
    // with an items array. Every failure path below still ends in a real
    // add: a rejected request retries without the add-on, and if that also
    // fails it falls through to the native form post. A customer must never
    // click Add to Cart and end up with nothing in it.
    // ==================================================================
    var form    = root.querySelector('form[id^="mbg-form-"]');
    // 'button.mbg__cta', NOT '[id^="mbg-cta-"]' — the prefix selector also
    // matches mbg-cta-text-* and mbg-cta-sub-*, so it would return the label
    // span instead of the button and every disable/enable would silently no-op.
    var ctaBtn  = root.querySelector('button.mbg__cta');
    var upBox   = root.querySelector('[data-mbgup]');
    var upCb    = root.querySelector('[data-mbgup-toggle]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;

    function upsellWanted(){
      return !!(upBox && upCb && upCb.checked && !upBox.classList.contains('is-off'));
    }

    // Make declining VISIBLE. The card is pre-checked, so if the two states
    // look alike the customer cannot tell whether the add-on is in their
    // order — which reads as a dark pattern and costs the sale either way.
    // 'is-declined' is purely cosmetic; 'is-off' still means hidden.
    // The toggle itself is native (the whole card is the <label>), so this
    // listener only mirrors state — it never drives it.
    // Match the BOTTLE's height to the copy column beside it — top edge level
    // with the title's top, bottom edge level with the YOU SAVE badge's bottom.
    // Done in JS because CSS cannot derive one element's height from a
    // sibling's. The only pure-CSS route is stretching the copy column to the
    // image instead, which moves the text — not what was asked for. Nothing
    // here touches the copy's spacing; it only ever resizes the image.
    //
    // The CSS height is the no-JS fallback. It carries !important, so the
    // inline override MUST be set with priority or it silently loses.
    var upCopy = upBox && upBox.querySelector('.mbgup__copy');
    var upImg  = upBox && upBox.querySelector('.mbgup__media img');
    function syncUpsellMediaHeight(){
      if (!upCopy || !upImg) return;
      var h = upCopy.getBoundingClientRect().height;
      if (h <= 0) return;
      // Only write on a real change — guards against a ResizeObserver loop.
      if (Math.abs(parseFloat(upImg.style.height || '0') - h) < 0.5) return;
      upImg.style.setProperty('height', h + 'px', 'important');
    }
    if (upCopy && upImg){
      // Debounced with a self-clearing timeout, NOT a rAF guard flag.
      // A `if (pending) return;` gate around requestAnimationFrame deadlocks
      // permanently the moment one rAF callback fails to run — which happens
      // whenever the page is not considered visible (background tab, embedded
      // preview pane), because rAF is throttled there while timers still fire.
      // The flag then stays set and every future resize is silently dropped.
      // clearTimeout+reassign has no such trap: the latest call always wins.
      var upTimer = 0;
      function scheduleUpsellSync(){
        if (upTimer) clearTimeout(upTimer);
        upTimer = setTimeout(function(){
          upTimer = 0; syncUpsellMediaHeight();
        }, 40);
      }

      syncUpsellMediaHeight();

      // Bind resize ALWAYS — never treat ResizeObserver as sufficient.
      // Verified on this storefront: ResizeObserver exists but never fires,
      // not even the guaranteed initial callback, because a third-party
      // script has stubbed it. The old code only attached this listener when
      // ResizeObserver was ABSENT, so on this store nothing ever re-ran and
      // the bottle stayed frozen at its first-paint height while the copy
      // reflowed around it. Treat RO as a bonus, not the mechanism.
      window.addEventListener('resize', scheduleUpsellSync);
      window.addEventListener('orientationchange', scheduleUpsellSync);
      if (window.ResizeObserver){
        try { new ResizeObserver(scheduleUpsellSync).observe(upCopy); } catch (e) {}
      }

      // The webfont swap changes the copy's height after first paint.
      if (document.fonts && document.fonts.ready){
        document.fonts.ready.then(syncUpsellMediaHeight).catch(function(){});
      }
      // Late reflow catch-all: font swap, lazily-loaded media above the card,
      // and app scripts that inject content after load all move the copy.
      var upDelays = [120, 400, 1200, 2500];
      for (var d = 0; d < upDelays.length; d++) setTimeout(syncUpsellMediaHeight, upDelays[d]);

      // Event-independent backstop. Neither ResizeObserver nor the window
      // 'resize' event can be relied on here: RO is stubbed by a third-party
      // script on this storefront, and some embedded/preview viewports change
      // width without emitting 'resize' at all. Both were verified dead on
      // this page. So poll briefly and cheaply instead of trusting either.
      // syncUpsellMediaHeight early-returns when already within 0.5px, so a
      // steady-state tick is one getBoundingClientRect and nothing else.
      // Self-terminating: 30 ticks x 500ms = 15s, which comfortably covers
      // font swap, lazy media above the card, and late app injection. After
      // that the resize listener handles real user resizes in a real browser.
      var upPolls = 0;
      var upPoll = setInterval(function(){
        syncUpsellMediaHeight();
        if (++upPolls >= 30) clearInterval(upPoll);
      }, 500);
    }

    function syncUpsellState(){
      if (!upBox || !upCb) return;
      upBox.classList.toggle('is-declined', !upCb.checked);
    }
    if (upCb){
      upCb.addEventListener('change', syncUpsellState);
      syncUpsellState();
    }

    function openCartDrawer(){
      // Verified against the live AJ storefront: UpCart V2 exposes
      // upcartRefreshCart and upcartOpenCart as TOP-LEVEL window functions,
      // not as methods on window.upcart. Refresh before opening or the drawer
      // paints its preloaded snapshot and the lines we just added are missing.
      try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
      try {
        if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
        else if (window.upcart && typeof window.upcart.openCart === 'function') window.upcart.openCart();
      } catch (e) {}
      // Theme-native fallbacks, for any theme where UpCart is absent.
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
        document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
      } catch (e) {}
      var trigger = document.querySelector('#upcart-cart-trigger,.upcart-trigger,[data-upcart-open]');
      if (trigger){ try { trigger.click(); } catch (e) {} }
      var dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && typeof dawnDrawer.open === 'function'){ try { dawnDrawer.open(); } catch (e) {} }

      // Verify, then fall back. No drawer after ~1s means there is no drawer.
      setTimeout(function(){
        var opened = document.body.classList.contains('upcartPopupShow') ||
                     document.body.classList.contains('upcart-open') ||
                     !!document.querySelector('cart-drawer.active, .drawer.active, #CartDrawer.active');
        if (!opened) window.location.href = '/cart';
      }, 1000);
    }

    function postItems(items){
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: items})
      }).then(function(r){
        if (!r.ok){
          return r.json().catch(function(){ return {}; }).then(function(b){
            var err = new Error('cart/add failed');
            err.status = r.status;
            err.body = b;
            throw err;
          });
        }
        return r.json();
      });
    }

    // Tell UpCart to keep its hands off this buy box.
    //
    // upcartShouldSkipAddToCart is UpCart's own documented opt-out hook
    // (it ships as `e => false`). CHAIN it rather than replace it: anything
    // originating inside a .mbg section is ours to handle, everything else
    // falls through to whatever UpCart or another section already installed,
    // so no other add-to-cart on the page changes behaviour. Installed once
    // per page, not once per section. This is the belt to the type="button"
    // braces above — either alone is sufficient.
    if (!window.__mbgUpcartHooked){
      window.__mbgUpcartHooked = true;
      var priorSkip = window.upcartShouldSkipAddToCart;
      window.upcartShouldSkipAddToCart = function(ev){
        try {
          var t = ev && (ev.target || ev.srcElement);
          if (t && t.closest && t.closest('.mbg')) return true;
        } catch (e) {}
        try { return typeof priorSkip === 'function' ? priorSkip(ev) : false; }
        catch (e) { return false; }
      };
    }

    // The add itself. Shared by the CTA click and the Enter-key guard.
    function doAddToCart(){
      // No fetch = ancient browser. form.submit() is a real browser POST and
      // fires no submit listeners, so nothing can intercept it either.
      if (typeof window.fetch !== 'function'){ if (form) form.submit(); return; }

      var mainId = idInput && idInput.value;
      if (!mainId){ if (form) form.submit(); return; }

      var mainItem = {id: parseInt(mainId, 10), quantity: qty};
      if (planInput && planInput.value) mainItem.selling_plan = planInput.value;

      var items = [mainItem];
      var addOn = null;
      if (upsellWanted()){
        var upId = parseInt(upBox.getAttribute('data-mbgup-variant'), 10);
        if (upId){
          addOn = {id: upId, quantity: 1};
          // Attribution rides ON the add-on line, never on the cart. It therefore
          // survives exactly as long as the line does: rejected on add, or removed
          // in the drawer, means no property and so no order tag. Hidden from the
          // customer by the leading underscore; still readable by Flow and the API.
          var upSrc = (upBox.getAttribute('data-mbgup-source') || '').trim();
          if (upSrc){ addOn.properties = {'_upsell_source': upSrc}; }
          items.push(addOn);
        }
      }

      if (ctaBtn){ ctaBtn.disabled = true; ctaBtn.style.opacity = '.72'; }
      function release(){ if (ctaBtn){ ctaBtn.disabled = false; ctaBtn.style.opacity = ''; } }

      postItems(items)
        .then(function(){ release(); openCartDrawer(); })
        .catch(function(){
          // The add-on is the fragile line: it is Locksmith-locked and it is
          // oversold. Never let it take the main product down with it.
          if (!addOn){ release(); if (form) form.submit(); return; }
          postItems([mainItem])
            .then(function(){
              release();
              if (upCb) upCb.checked = false;
              openCartDrawer();
            })
            .catch(function(){ release(); if (form) form.submit(); });
        });
    }

    if (ctaBtn){
      ctaBtn.addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        doAddToCart();
      });
    }

    // Enter inside the form still raises a submit even with no submit button.
    // Catch it in the CAPTURE phase so we beat any cart app listening on bubble.
    if (form){
      form.addEventListener('submit', function(ev){
        ev.preventDefault();
        ev.stopImmediatePropagation();
        doAddToCart();
      }, true);
    }

    // Gallery
    var mainBox = root.querySelector('.mbg__main');
    var main = root.querySelector('.mbg__main img');
    var countEl = root.querySelector('[id^="mbg-count-"]');
    var thumbsContainer = root.querySelector('.mbg__thumbs');
    var thumbs = root.querySelectorAll('.mbg__thumb');
    var prev = root.querySelector('[id^="mbg-prev-"]');
    var next = root.querySelector('[id^="mbg-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src){
        // Re-point the intrinsic ratio BEFORE swapping src, so the box resizes
        // in one step instead of holding the previous image's height until the
        // new one decodes. Keeps every image at its true shape, uncropped.
        var tw = thumbs[idx].dataset.w, th = thumbs[idx].dataset.h;
        if (tw && th){ main.setAttribute('width', tw); main.setAttribute('height', th); }
        main.src = src;
      }
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._mbgDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._mbgDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._mbgDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._mbgDragged = false; }, 100);
        } else {
          thumbsContainer._mbgDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._mbgDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["00-00-mr-upsell"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.mrt');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.mrtInit === '1') continue;
      el.dataset.mrtInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[mrt]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.mrt__plan-card');
    var qtyRows   = root.querySelectorAll('.mrt__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="mrt-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="mrt-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.mrt__qty-row[data-qty="2"] .mrt__qty-extra');

    function getActiveQtyRow(){
      return root.querySelector('.mrt__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.mrt__qty-now');
        var saveEl  = b.querySelector('.mrt__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
      }
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Subscription selected · Cancel anytime';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no subscription';
        }
      }
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // ==================================================================
    // IODINE UPSELL + AJAX CART
    //
    // A Shopify product form posts exactly ONE variant, so the moment a
    // second product is involved the submit has to go through /cart/add.js
    // with an items array. Every failure path below still ends in a real
    // add: a rejected request retries without the add-on, and if that also
    // fails it falls through to the native form post. A customer must never
    // click Add to Cart and end up with nothing in it.
    // ==================================================================
    var form    = root.querySelector('form[id^="mrt-form-"]');
    // 'button.mrt__cta', NOT '[id^="mrt-cta-"]' — the prefix selector also
    // matches mrt-cta-text-* and mrt-cta-sub-*, so it would return the label
    // span instead of the button and every disable/enable would silently no-op.
    var ctaBtn  = root.querySelector('button.mrt__cta');
    var upBox   = root.querySelector('[data-mrtup]');
    var upCb    = root.querySelector('[data-mrtup-toggle]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;

    function upsellWanted(){
      return !!(upBox && upCb && upCb.checked && !upBox.classList.contains('is-off'));
    }

    // Make declining VISIBLE. The card is pre-checked, so if the two states
    // look alike the customer cannot tell whether the add-on is in their
    // order — which reads as a dark pattern and costs the sale either way.
    // 'is-declined' is purely cosmetic; 'is-off' still means hidden.
    // The toggle itself is native (the whole card is the <label>), so this
    // listener only mirrors state — it never drives it.
    // Match the BOTTLE's height to the copy column beside it — top edge level
    // with the title's top, bottom edge level with the YOU SAVE badge's bottom.
    // Done in JS because CSS cannot derive one element's height from a
    // sibling's. The only pure-CSS route is stretching the copy column to the
    // image instead, which moves the text — not what was asked for. Nothing
    // here touches the copy's spacing; it only ever resizes the image.
    //
    // The CSS height is the no-JS fallback. It carries !important, so the
    // inline override MUST be set with priority or it silently loses.
    var upCopy = upBox && upBox.querySelector('.mrtup__copy');
    var upImg  = upBox && upBox.querySelector('.mrtup__media img');
    function syncUpsellMediaHeight(){
      if (!upCopy || !upImg) return;
      var h = upCopy.getBoundingClientRect().height;
      if (h <= 0) return;
      // Only write on a real change — guards against a ResizeObserver loop.
      if (Math.abs(parseFloat(upImg.style.height || '0') - h) < 0.5) return;
      upImg.style.setProperty('height', h + 'px', 'important');
    }
    if (upCopy && upImg){
      // Debounced with a self-clearing timeout, NOT a rAF guard flag.
      // A `if (pending) return;` gate around requestAnimationFrame deadlocks
      // permanently the moment one rAF callback fails to run — which happens
      // whenever the page is not considered visible (background tab, embedded
      // preview pane), because rAF is throttled there while timers still fire.
      // The flag then stays set and every future resize is silently dropped.
      // clearTimeout+reassign has no such trap: the latest call always wins.
      var upTimer = 0;
      function scheduleUpsellSync(){
        if (upTimer) clearTimeout(upTimer);
        upTimer = setTimeout(function(){
          upTimer = 0; syncUpsellMediaHeight();
        }, 40);
      }

      syncUpsellMediaHeight();

      // Bind resize ALWAYS — never treat ResizeObserver as sufficient.
      // Verified on this storefront: ResizeObserver exists but never fires,
      // not even the guaranteed initial callback, because a third-party
      // script has stubbed it. The old code only attached this listener when
      // ResizeObserver was ABSENT, so on this store nothing ever re-ran and
      // the bottle stayed frozen at its first-paint height while the copy
      // reflowed around it. Treat RO as a bonus, not the mechanism.
      window.addEventListener('resize', scheduleUpsellSync);
      window.addEventListener('orientationchange', scheduleUpsellSync);
      if (window.ResizeObserver){
        try { new ResizeObserver(scheduleUpsellSync).observe(upCopy); } catch (e) {}
      }

      // The webfont swap changes the copy's height after first paint.
      if (document.fonts && document.fonts.ready){
        document.fonts.ready.then(syncUpsellMediaHeight).catch(function(){});
      }
      // Late reflow catch-all: font swap, lazily-loaded media above the card,
      // and app scripts that inject content after load all move the copy.
      var upDelays = [120, 400, 1200, 2500];
      for (var d = 0; d < upDelays.length; d++) setTimeout(syncUpsellMediaHeight, upDelays[d]);

      // Event-independent backstop. Neither ResizeObserver nor the window
      // 'resize' event can be relied on here: RO is stubbed by a third-party
      // script on this storefront, and some embedded/preview viewports change
      // width without emitting 'resize' at all. Both were verified dead on
      // this page. So poll briefly and cheaply instead of trusting either.
      // syncUpsellMediaHeight early-returns when already within 0.5px, so a
      // steady-state tick is one getBoundingClientRect and nothing else.
      // Self-terminating: 30 ticks x 500ms = 15s, which comfortably covers
      // font swap, lazy media above the card, and late app injection. After
      // that the resize listener handles real user resizes in a real browser.
      var upPolls = 0;
      var upPoll = setInterval(function(){
        syncUpsellMediaHeight();
        if (++upPolls >= 30) clearInterval(upPoll);
      }, 500);
    }

    function syncUpsellState(){
      if (!upBox || !upCb) return;
      upBox.classList.toggle('is-declined', !upCb.checked);
    }
    if (upCb){
      upCb.addEventListener('change', syncUpsellState);
      syncUpsellState();
    }

    function openCartDrawer(){
      // Verified against the live AJ storefront: UpCart V2 exposes
      // upcartRefreshCart and upcartOpenCart as TOP-LEVEL window functions,
      // not as methods on window.upcart. Refresh before opening or the drawer
      // paints its preloaded snapshot and the lines we just added are missing.
      try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
      try {
        if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
        else if (window.upcart && typeof window.upcart.openCart === 'function') window.upcart.openCart();
      } catch (e) {}
      // Theme-native fallbacks, for any theme where UpCart is absent.
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
        document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
      } catch (e) {}
      var trigger = document.querySelector('#upcart-cart-trigger,.upcart-trigger,[data-upcart-open]');
      if (trigger){ try { trigger.click(); } catch (e) {} }
      var dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && typeof dawnDrawer.open === 'function'){ try { dawnDrawer.open(); } catch (e) {} }

      // Verify, then fall back. No drawer after ~1s means there is no drawer.
      setTimeout(function(){
        var opened = document.body.classList.contains('upcartPopupShow') ||
                     document.body.classList.contains('upcart-open') ||
                     !!document.querySelector('cart-drawer.active, .drawer.active, #CartDrawer.active');
        if (!opened) window.location.href = '/cart';
      }, 1000);
    }

    function postItems(items){
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: items})
      }).then(function(r){
        if (!r.ok){
          return r.json().catch(function(){ return {}; }).then(function(b){
            var err = new Error('cart/add failed');
            err.status = r.status;
            err.body = b;
            throw err;
          });
        }
        return r.json();
      });
    }

    // Tell UpCart to keep its hands off this buy box.
    //
    // upcartShouldSkipAddToCart is UpCart's own documented opt-out hook
    // (it ships as `e => false`). CHAIN it rather than replace it: anything
    // originating inside a .mrt section is ours to handle, everything else
    // falls through to whatever UpCart or another section already installed,
    // so no other add-to-cart on the page changes behaviour. Installed once
    // per page, not once per section. This is the belt to the type="button"
    // braces above — either alone is sufficient.
    if (!window.__mrtUpcartHooked){
      window.__mrtUpcartHooked = true;
      var priorSkip = window.upcartShouldSkipAddToCart;
      window.upcartShouldSkipAddToCart = function(ev){
        try {
          var t = ev && (ev.target || ev.srcElement);
          if (t && t.closest && t.closest('.mrt')) return true;
        } catch (e) {}
        try { return typeof priorSkip === 'function' ? priorSkip(ev) : false; }
        catch (e) { return false; }
      };
    }

    // The add itself. Shared by the CTA click and the Enter-key guard.
    function doAddToCart(){
      // No fetch = ancient browser. form.submit() is a real browser POST and
      // fires no submit listeners, so nothing can intercept it either.
      if (typeof window.fetch !== 'function'){ if (form) form.submit(); return; }

      var mainId = idInput && idInput.value;
      if (!mainId){ if (form) form.submit(); return; }

      var mainItem = {id: parseInt(mainId, 10), quantity: qty};
      if (planInput && planInput.value) mainItem.selling_plan = planInput.value;

      var items = [mainItem];
      var addOn = null;
      if (upsellWanted()){
        var upId = parseInt(upBox.getAttribute('data-mrtup-variant'), 10);
        if (upId){
          addOn = {id: upId, quantity: 1};
          // Attribution rides ON the add-on line, never on the cart. It therefore
          // survives exactly as long as the line does: rejected on add, or removed
          // in the drawer, means no property and so no order tag. Hidden from the
          // customer by the leading underscore; still readable by Flow and the API.
          var upSrc = (upBox.getAttribute('data-mrtup-source') || '').trim();
          if (upSrc){ addOn.properties = {'_upsell_source': upSrc}; }
          items.push(addOn);
        }
      }

      if (ctaBtn){ ctaBtn.disabled = true; ctaBtn.style.opacity = '.72'; }
      function release(){ if (ctaBtn){ ctaBtn.disabled = false; ctaBtn.style.opacity = ''; } }

      postItems(items)
        .then(function(){ release(); openCartDrawer(); })
        .catch(function(){
          // The add-on is the fragile line: it is Locksmith-locked and it is
          // oversold. Never let it take the main product down with it.
          if (!addOn){ release(); if (form) form.submit(); return; }
          postItems([mainItem])
            .then(function(){
              release();
              if (upCb) upCb.checked = false;
              openCartDrawer();
            })
            .catch(function(){ release(); if (form) form.submit(); });
        });
    }

    if (ctaBtn){
      ctaBtn.addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        doAddToCart();
      });
    }

    // Enter inside the form still raises a submit even with no submit button.
    // Catch it in the CAPTURE phase so we beat any cart app listening on bubble.
    if (form){
      form.addEventListener('submit', function(ev){
        ev.preventDefault();
        ev.stopImmediatePropagation();
        doAddToCart();
      }, true);
    }

    // Gallery
    var mainBox = root.querySelector('.mrt__main');
    var main = root.querySelector('.mrt__main img');
    var countEl = root.querySelector('[id^="mrt-count-"]');
    var thumbsContainer = root.querySelector('.mrt__thumbs');
    var thumbs = root.querySelectorAll('.mrt__thumb');
    var prev = root.querySelector('[id^="mrt-prev-"]');
    var next = root.querySelector('[id^="mrt-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src){
        // Re-point the intrinsic ratio BEFORE swapping src, so the box resizes
        // in one step instead of holding the previous image's height until the
        // new one decodes. Keeps every image at its true shape, uncropped.
        var tw = thumbs[idx].dataset.w, th = thumbs[idx].dataset.h;
        if (tw && th){ main.setAttribute('width', tw); main.setAttribute('height', th); }
        main.src = src;
      }
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._mrtDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._mrtDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._mrtDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._mrtDragged = false; }, 100);
        } else {
          thumbsContainer._mrtDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._mrtDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["00-00-t3i-upsell"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.t3i');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.t3iInit === '1') continue;
      el.dataset.t3iInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[t3i]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.t3i__plan-card');
    var qtyRows   = root.querySelectorAll('.t3i__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="t3i-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="t3i-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.t3i__qty-row[data-qty="2"] .t3i__qty-extra');

    function getActiveQtyRow(){
      return root.querySelector('.t3i__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.t3i__qty-now');
        var saveEl  = b.querySelector('.t3i__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
      }
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Subscription selected · Cancel anytime';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no subscription';
        }
      }
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // ==================================================================
    // IODINE UPSELL + AJAX CART
    //
    // A Shopify product form posts exactly ONE variant, so the moment a
    // second product is involved the submit has to go through /cart/add.js
    // with an items array. Every failure path below still ends in a real
    // add: a rejected request retries without the add-on, and if that also
    // fails it falls through to the native form post. A customer must never
    // click Add to Cart and end up with nothing in it.
    // ==================================================================
    var form    = root.querySelector('form[id^="t3i-form-"]');
    // 'button.t3i__cta', NOT '[id^="t3i-cta-"]' — the prefix selector also
    // matches t3i-cta-text-* and t3i-cta-sub-*, so it would return the label
    // span instead of the button and every disable/enable would silently no-op.
    var ctaBtn  = root.querySelector('button.t3i__cta');
    var upBox   = root.querySelector('[data-t3iup]');
    var upCb    = root.querySelector('[data-t3iup-toggle]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;

    function upsellWanted(){
      return !!(upBox && upCb && upCb.checked && !upBox.classList.contains('is-off'));
    }

    // Make declining VISIBLE. The card is pre-checked, so if the two states
    // look alike the customer cannot tell whether the add-on is in their
    // order — which reads as a dark pattern and costs the sale either way.
    // 'is-declined' is purely cosmetic; 'is-off' still means hidden.
    // The toggle itself is native (the whole card is the <label>), so this
    // listener only mirrors state — it never drives it.
    // Match the BOTTLE's height to the copy column beside it — top edge level
    // with the title's top, bottom edge level with the YOU SAVE badge's bottom.
    // Done in JS because CSS cannot derive one element's height from a
    // sibling's. The only pure-CSS route is stretching the copy column to the
    // image instead, which moves the text — not what was asked for. Nothing
    // here touches the copy's spacing; it only ever resizes the image.
    //
    // The CSS height is the no-JS fallback. It carries !important, so the
    // inline override MUST be set with priority or it silently loses.
    var upCopy = upBox && upBox.querySelector('.t3iup__copy');
    var upImg  = upBox && upBox.querySelector('.t3iup__media img');
    function syncUpsellMediaHeight(){
      if (!upCopy || !upImg) return;
      var h = upCopy.getBoundingClientRect().height;
      if (h <= 0) return;
      // Only write on a real change — guards against a ResizeObserver loop.
      if (Math.abs(parseFloat(upImg.style.height || '0') - h) < 0.5) return;
      upImg.style.setProperty('height', h + 'px', 'important');
    }
    if (upCopy && upImg){
      // Debounced with a self-clearing timeout, NOT a rAF guard flag.
      // A `if (pending) return;` gate around requestAnimationFrame deadlocks
      // permanently the moment one rAF callback fails to run — which happens
      // whenever the page is not considered visible (background tab, embedded
      // preview pane), because rAF is throttled there while timers still fire.
      // The flag then stays set and every future resize is silently dropped.
      // clearTimeout+reassign has no such trap: the latest call always wins.
      var upTimer = 0;
      function scheduleUpsellSync(){
        if (upTimer) clearTimeout(upTimer);
        upTimer = setTimeout(function(){
          upTimer = 0; syncUpsellMediaHeight();
        }, 40);
      }

      syncUpsellMediaHeight();

      // Bind resize ALWAYS — never treat ResizeObserver as sufficient.
      // Verified on this storefront: ResizeObserver exists but never fires,
      // not even the guaranteed initial callback, because a third-party
      // script has stubbed it. The old code only attached this listener when
      // ResizeObserver was ABSENT, so on this store nothing ever re-ran and
      // the bottle stayed frozen at its first-paint height while the copy
      // reflowed around it. Treat RO as a bonus, not the mechanism.
      window.addEventListener('resize', scheduleUpsellSync);
      window.addEventListener('orientationchange', scheduleUpsellSync);
      if (window.ResizeObserver){
        try { new ResizeObserver(scheduleUpsellSync).observe(upCopy); } catch (e) {}
      }

      // The webfont swap changes the copy's height after first paint.
      if (document.fonts && document.fonts.ready){
        document.fonts.ready.then(syncUpsellMediaHeight).catch(function(){});
      }
      // Late reflow catch-all: font swap, lazily-loaded media above the card,
      // and app scripts that inject content after load all move the copy.
      var upDelays = [120, 400, 1200, 2500];
      for (var d = 0; d < upDelays.length; d++) setTimeout(syncUpsellMediaHeight, upDelays[d]);

      // Event-independent backstop. Neither ResizeObserver nor the window
      // 'resize' event can be relied on here: RO is stubbed by a third-party
      // script on this storefront, and some embedded/preview viewports change
      // width without emitting 'resize' at all. Both were verified dead on
      // this page. So poll briefly and cheaply instead of trusting either.
      // syncUpsellMediaHeight early-returns when already within 0.5px, so a
      // steady-state tick is one getBoundingClientRect and nothing else.
      // Self-terminating: 30 ticks x 500ms = 15s, which comfortably covers
      // font swap, lazy media above the card, and late app injection. After
      // that the resize listener handles real user resizes in a real browser.
      var upPolls = 0;
      var upPoll = setInterval(function(){
        syncUpsellMediaHeight();
        if (++upPolls >= 30) clearInterval(upPoll);
      }, 500);
    }

    function syncUpsellState(){
      if (!upBox || !upCb) return;
      upBox.classList.toggle('is-declined', !upCb.checked);
    }
    if (upCb){
      upCb.addEventListener('change', syncUpsellState);
      syncUpsellState();
    }

    function openCartDrawer(){
      // Verified against the live AJ storefront: UpCart V2 exposes
      // upcartRefreshCart and upcartOpenCart as TOP-LEVEL window functions,
      // not as methods on window.upcart. Refresh before opening or the drawer
      // paints its preloaded snapshot and the lines we just added are missing.
      try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
      try {
        if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
        else if (window.upcart && typeof window.upcart.openCart === 'function') window.upcart.openCart();
      } catch (e) {}
      // Theme-native fallbacks, for any theme where UpCart is absent.
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
        document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
      } catch (e) {}
      var trigger = document.querySelector('#upcart-cart-trigger,.upcart-trigger,[data-upcart-open]');
      if (trigger){ try { trigger.click(); } catch (e) {} }
      var dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && typeof dawnDrawer.open === 'function'){ try { dawnDrawer.open(); } catch (e) {} }

      // Verify, then fall back. No drawer after ~1s means there is no drawer.
      setTimeout(function(){
        var opened = document.body.classList.contains('upcartPopupShow') ||
                     document.body.classList.contains('upcart-open') ||
                     !!document.querySelector('cart-drawer.active, .drawer.active, #CartDrawer.active');
        if (!opened) window.location.href = '/cart';
      }, 1000);
    }

    function postItems(items){
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: items})
      }).then(function(r){
        if (!r.ok){
          return r.json().catch(function(){ return {}; }).then(function(b){
            var err = new Error('cart/add failed');
            err.status = r.status;
            err.body = b;
            throw err;
          });
        }
        return r.json();
      });
    }

    // Tell UpCart to keep its hands off this buy box.
    //
    // upcartShouldSkipAddToCart is UpCart's own documented opt-out hook
    // (it ships as `e => false`). CHAIN it rather than replace it: anything
    // originating inside a .t3i section is ours to handle, everything else
    // falls through to whatever UpCart or another section already installed,
    // so no other add-to-cart on the page changes behaviour. Installed once
    // per page, not once per section. This is the belt to the type="button"
    // braces above — either alone is sufficient.
    if (!window.__t3iUpcartHooked){
      window.__t3iUpcartHooked = true;
      var priorSkip = window.upcartShouldSkipAddToCart;
      window.upcartShouldSkipAddToCart = function(ev){
        try {
          var t = ev && (ev.target || ev.srcElement);
          if (t && t.closest && t.closest('.t3i')) return true;
        } catch (e) {}
        try { return typeof priorSkip === 'function' ? priorSkip(ev) : false; }
        catch (e) { return false; }
      };
    }

    // The add itself. Shared by the CTA click and the Enter-key guard.
    function doAddToCart(){
      // No fetch = ancient browser. form.submit() is a real browser POST and
      // fires no submit listeners, so nothing can intercept it either.
      if (typeof window.fetch !== 'function'){ if (form) form.submit(); return; }

      var mainId = idInput && idInput.value;
      if (!mainId){ if (form) form.submit(); return; }

      var mainItem = {id: parseInt(mainId, 10), quantity: qty};
      if (planInput && planInput.value) mainItem.selling_plan = planInput.value;

      var items = [mainItem];
      var addOn = null;
      if (upsellWanted()){
        var upId = parseInt(upBox.getAttribute('data-t3iup-variant'), 10);
        if (upId){
          addOn = {id: upId, quantity: 1};
          // Attribution rides ON the add-on line, never on the cart. It therefore
          // survives exactly as long as the line does: rejected on add, or removed
          // in the drawer, means no property and so no order tag. Hidden from the
          // customer by the leading underscore; still readable by Flow and the API.
          var upSrc = (upBox.getAttribute('data-t3iup-source') || '').trim();
          if (upSrc){ addOn.properties = {'_upsell_source': upSrc}; }
          items.push(addOn);
        }
      }

      if (ctaBtn){ ctaBtn.disabled = true; ctaBtn.style.opacity = '.72'; }
      function release(){ if (ctaBtn){ ctaBtn.disabled = false; ctaBtn.style.opacity = ''; } }

      postItems(items)
        .then(function(){ release(); openCartDrawer(); })
        .catch(function(){
          // The add-on is the fragile line: it is Locksmith-locked and it is
          // oversold. Never let it take the main product down with it.
          if (!addOn){ release(); if (form) form.submit(); return; }
          postItems([mainItem])
            .then(function(){
              release();
              if (upCb) upCb.checked = false;
              openCartDrawer();
            })
            .catch(function(){ release(); if (form) form.submit(); });
        });
    }

    if (ctaBtn){
      ctaBtn.addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        doAddToCart();
      });
    }

    // Enter inside the form still raises a submit even with no submit button.
    // Catch it in the CAPTURE phase so we beat any cart app listening on bubble.
    if (form){
      form.addEventListener('submit', function(ev){
        ev.preventDefault();
        ev.stopImmediatePropagation();
        doAddToCart();
      }, true);
    }

    // Gallery
    var mainBox = root.querySelector('.t3i__main');
    var main = root.querySelector('.t3i__main img');
    var countEl = root.querySelector('[id^="t3i-count-"]');
    var thumbsContainer = root.querySelector('.t3i__thumbs');
    var thumbs = root.querySelectorAll('.t3i__thumb');
    var prev = root.querySelector('[id^="t3i-prev-"]');
    var next = root.querySelector('[id^="t3i-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src){
        // Re-point the intrinsic ratio BEFORE swapping src, so the box resizes
        // in one step instead of holding the previous image's height until the
        // new one decodes. Keeps every image at its true shape, uncropped.
        var tw = thumbs[idx].dataset.w, th = thumbs[idx].dataset.h;
        if (tw && th){ main.setAttribute('width', tw); main.setAttribute('height', th); }
        main.src = src;
      }
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._t3iDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._t3iDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._t3iDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._t3iDragged = false; }, 100);
        } else {
          thumbsContainer._t3iDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._t3iDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["00-00-zeo-upsell"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.zeo');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.zeoInit === '1') continue;
      el.dataset.zeoInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[zeo]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.zeo__plan-card');
    var qtyRows   = root.querySelectorAll('.zeo__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="zeo-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="zeo-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.zeo__qty-row[data-qty="2"] .zeo__qty-extra');

    function getActiveQtyRow(){
      return root.querySelector('.zeo__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.zeo__qty-now');
        var saveEl  = b.querySelector('.zeo__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
      }
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Subscription selected · Cancel anytime';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no subscription';
        }
      }
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // ==================================================================
    // IODINE UPSELL + AJAX CART
    //
    // A Shopify product form posts exactly ONE variant, so the moment a
    // second product is involved the submit has to go through /cart/add.js
    // with an items array. Every failure path below still ends in a real
    // add: a rejected request retries without the add-on, and if that also
    // fails it falls through to the native form post. A customer must never
    // click Add to Cart and end up with nothing in it.
    // ==================================================================
    var form    = root.querySelector('form[id^="zeo-form-"]');
    // 'button.zeo__cta', NOT '[id^="zeo-cta-"]' — the prefix selector also
    // matches zeo-cta-text-* and zeo-cta-sub-*, so it would return the label
    // span instead of the button and every disable/enable would silently no-op.
    var ctaBtn  = root.querySelector('button.zeo__cta');
    var upBox   = root.querySelector('[data-zeoup]');
    var upCb    = root.querySelector('[data-zeoup-toggle]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;

    function upsellWanted(){
      return !!(upBox && upCb && upCb.checked && !upBox.classList.contains('is-off'));
    }

    // Make declining VISIBLE. The card is pre-checked, so if the two states
    // look alike the customer cannot tell whether the add-on is in their
    // order — which reads as a dark pattern and costs the sale either way.
    // 'is-declined' is purely cosmetic; 'is-off' still means hidden.
    // The toggle itself is native (the whole card is the <label>), so this
    // listener only mirrors state — it never drives it.
    // Match the BOTTLE's height to the copy column beside it — top edge level
    // with the title's top, bottom edge level with the YOU SAVE badge's bottom.
    // Done in JS because CSS cannot derive one element's height from a
    // sibling's. The only pure-CSS route is stretching the copy column to the
    // image instead, which moves the text — not what was asked for. Nothing
    // here touches the copy's spacing; it only ever resizes the image.
    //
    // The CSS height is the no-JS fallback. It carries !important, so the
    // inline override MUST be set with priority or it silently loses.
    var upCopy = upBox && upBox.querySelector('.zeoup__copy');
    var upImg  = upBox && upBox.querySelector('.zeoup__media img');
    function syncUpsellMediaHeight(){
      if (!upCopy || !upImg) return;
      var h = upCopy.getBoundingClientRect().height;
      if (h <= 0) return;
      // Only write on a real change — guards against a ResizeObserver loop.
      if (Math.abs(parseFloat(upImg.style.height || '0') - h) < 0.5) return;
      upImg.style.setProperty('height', h + 'px', 'important');
    }
    if (upCopy && upImg){
      // Debounced with a self-clearing timeout, NOT a rAF guard flag.
      // A `if (pending) return;` gate around requestAnimationFrame deadlocks
      // permanently the moment one rAF callback fails to run — which happens
      // whenever the page is not considered visible (background tab, embedded
      // preview pane), because rAF is throttled there while timers still fire.
      // The flag then stays set and every future resize is silently dropped.
      // clearTimeout+reassign has no such trap: the latest call always wins.
      var upTimer = 0;
      function scheduleUpsellSync(){
        if (upTimer) clearTimeout(upTimer);
        upTimer = setTimeout(function(){
          upTimer = 0; syncUpsellMediaHeight();
        }, 40);
      }

      syncUpsellMediaHeight();

      // Bind resize ALWAYS — never treat ResizeObserver as sufficient.
      // Verified on this storefront: ResizeObserver exists but never fires,
      // not even the guaranteed initial callback, because a third-party
      // script has stubbed it. The old code only attached this listener when
      // ResizeObserver was ABSENT, so on this store nothing ever re-ran and
      // the bottle stayed frozen at its first-paint height while the copy
      // reflowed around it. Treat RO as a bonus, not the mechanism.
      window.addEventListener('resize', scheduleUpsellSync);
      window.addEventListener('orientationchange', scheduleUpsellSync);
      if (window.ResizeObserver){
        try { new ResizeObserver(scheduleUpsellSync).observe(upCopy); } catch (e) {}
      }

      // The webfont swap changes the copy's height after first paint.
      if (document.fonts && document.fonts.ready){
        document.fonts.ready.then(syncUpsellMediaHeight).catch(function(){});
      }
      // Late reflow catch-all: font swap, lazily-loaded media above the card,
      // and app scripts that inject content after load all move the copy.
      var upDelays = [120, 400, 1200, 2500];
      for (var d = 0; d < upDelays.length; d++) setTimeout(syncUpsellMediaHeight, upDelays[d]);

      // Event-independent backstop. Neither ResizeObserver nor the window
      // 'resize' event can be relied on here: RO is stubbed by a third-party
      // script on this storefront, and some embedded/preview viewports change
      // width without emitting 'resize' at all. Both were verified dead on
      // this page. So poll briefly and cheaply instead of trusting either.
      // syncUpsellMediaHeight early-returns when already within 0.5px, so a
      // steady-state tick is one getBoundingClientRect and nothing else.
      // Self-terminating: 30 ticks x 500ms = 15s, which comfortably covers
      // font swap, lazy media above the card, and late app injection. After
      // that the resize listener handles real user resizes in a real browser.
      var upPolls = 0;
      var upPoll = setInterval(function(){
        syncUpsellMediaHeight();
        if (++upPolls >= 30) clearInterval(upPoll);
      }, 500);
    }

    function syncUpsellState(){
      if (!upBox || !upCb) return;
      upBox.classList.toggle('is-declined', !upCb.checked);
    }
    if (upCb){
      upCb.addEventListener('change', syncUpsellState);
      syncUpsellState();
    }

    function openCartDrawer(){
      // Verified against the live AJ storefront: UpCart V2 exposes
      // upcartRefreshCart and upcartOpenCart as TOP-LEVEL window functions,
      // not as methods on window.upcart. Refresh before opening or the drawer
      // paints its preloaded snapshot and the lines we just added are missing.
      try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
      try {
        if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
        else if (window.upcart && typeof window.upcart.openCart === 'function') window.upcart.openCart();
      } catch (e) {}
      // Theme-native fallbacks, for any theme where UpCart is absent.
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
        document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
      } catch (e) {}
      var trigger = document.querySelector('#upcart-cart-trigger,.upcart-trigger,[data-upcart-open]');
      if (trigger){ try { trigger.click(); } catch (e) {} }
      var dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && typeof dawnDrawer.open === 'function'){ try { dawnDrawer.open(); } catch (e) {} }

      // Verify, then fall back. No drawer after ~1s means there is no drawer.
      setTimeout(function(){
        var opened = document.body.classList.contains('upcartPopupShow') ||
                     document.body.classList.contains('upcart-open') ||
                     !!document.querySelector('cart-drawer.active, .drawer.active, #CartDrawer.active');
        if (!opened) window.location.href = '/cart';
      }, 1000);
    }

    function postItems(items){
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: items})
      }).then(function(r){
        if (!r.ok){
          return r.json().catch(function(){ return {}; }).then(function(b){
            var err = new Error('cart/add failed');
            err.status = r.status;
            err.body = b;
            throw err;
          });
        }
        return r.json();
      });
    }

    // Tell UpCart to keep its hands off this buy box.
    //
    // upcartShouldSkipAddToCart is UpCart's own documented opt-out hook
    // (it ships as `e => false`). CHAIN it rather than replace it: anything
    // originating inside a .zeo section is ours to handle, everything else
    // falls through to whatever UpCart or another section already installed,
    // so no other add-to-cart on the page changes behaviour. Installed once
    // per page, not once per section. This is the belt to the type="button"
    // braces above — either alone is sufficient.
    if (!window.__zeoUpcartHooked){
      window.__zeoUpcartHooked = true;
      var priorSkip = window.upcartShouldSkipAddToCart;
      window.upcartShouldSkipAddToCart = function(ev){
        try {
          var t = ev && (ev.target || ev.srcElement);
          if (t && t.closest && t.closest('.zeo')) return true;
        } catch (e) {}
        try { return typeof priorSkip === 'function' ? priorSkip(ev) : false; }
        catch (e) { return false; }
      };
    }

    // The add itself. Shared by the CTA click and the Enter-key guard.
    function doAddToCart(){
      // No fetch = ancient browser. form.submit() is a real browser POST and
      // fires no submit listeners, so nothing can intercept it either.
      if (typeof window.fetch !== 'function'){ if (form) form.submit(); return; }

      var mainId = idInput && idInput.value;
      if (!mainId){ if (form) form.submit(); return; }

      var mainItem = {id: parseInt(mainId, 10), quantity: qty};
      if (planInput && planInput.value) mainItem.selling_plan = planInput.value;

      var items = [mainItem];
      var addOn = null;
      if (upsellWanted()){
        var upId = parseInt(upBox.getAttribute('data-zeoup-variant'), 10);
        if (upId){
          addOn = {id: upId, quantity: 1};
          // Attribution rides ON the add-on line, never on the cart. It therefore
          // survives exactly as long as the line does: rejected on add, or removed
          // in the drawer, means no property and so no order tag. Hidden from the
          // customer by the leading underscore; still readable by Flow and the API.
          var upSrc = (upBox.getAttribute('data-zeoup-source') || '').trim();
          if (upSrc){ addOn.properties = {'_upsell_source': upSrc}; }
          items.push(addOn);
        }
      }

      if (ctaBtn){ ctaBtn.disabled = true; ctaBtn.style.opacity = '.72'; }
      function release(){ if (ctaBtn){ ctaBtn.disabled = false; ctaBtn.style.opacity = ''; } }

      postItems(items)
        .then(function(){ release(); openCartDrawer(); })
        .catch(function(){
          // The add-on is the fragile line: it is Locksmith-locked and it is
          // oversold. Never let it take the main product down with it.
          if (!addOn){ release(); if (form) form.submit(); return; }
          postItems([mainItem])
            .then(function(){
              release();
              if (upCb) upCb.checked = false;
              openCartDrawer();
            })
            .catch(function(){ release(); if (form) form.submit(); });
        });
    }

    if (ctaBtn){
      ctaBtn.addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        doAddToCart();
      });
    }

    // Enter inside the form still raises a submit even with no submit button.
    // Catch it in the CAPTURE phase so we beat any cart app listening on bubble.
    if (form){
      form.addEventListener('submit', function(ev){
        ev.preventDefault();
        ev.stopImmediatePropagation();
        doAddToCart();
      }, true);
    }

    // Gallery
    var mainBox = root.querySelector('.zeo__main');
    var main = root.querySelector('.zeo__main img');
    var countEl = root.querySelector('[id^="zeo-count-"]');
    var thumbsContainer = root.querySelector('.zeo__thumbs');
    var thumbs = root.querySelectorAll('.zeo__thumb');
    var prev = root.querySelector('[id^="zeo-prev-"]');
    var next = root.querySelector('[id^="zeo-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src){
        // Re-point the intrinsic ratio BEFORE swapping src, so the box resizes
        // in one step instead of holding the previous image's height until the
        // new one decodes. Keeps every image at its true shape, uncropped.
        var tw = thumbs[idx].dataset.w, th = thumbs[idx].dataset.h;
        if (tw && th){ main.setAttribute('width', tw); main.setAttribute('height', th); }
        main.src = src;
      }
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._zeoDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._zeoDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._zeoDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._zeoDragged = false; }, 100);
        } else {
          thumbsContainer._zeoDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._zeoDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["26-buybox-universal-v2"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    // ===== Variants data =====
    var variants = [];
    var variantsScript = document.querySelector('script[data-bbx-variants="' + (root.id || '').replace('bbx-', '') + '"]');
    if (!variantsScript){
      // Fallback: find first variants script (single-section pages)
      variantsScript = document.querySelector('script[data-bbx-variants]');
    }
    if (variantsScript){
      try { variants = JSON.parse(variantsScript.textContent); } catch(e){}
    }

    // ===== Refs =====
    var optionGroups = root.querySelectorAll('.bbx__variant-group');
    var variantIdInput = root.querySelector('input[name="id"]');
    var qtyHiddenInput = root.querySelector('input[name="quantity"]');
    var qtyDisplay = root.querySelector('[data-qty-input]');
    var qtyMinus = root.querySelector('[data-qty-minus]');
    var qtyPlus = root.querySelector('[data-qty-plus]');
    var priceNowEl = root.querySelector('[data-bbx-price-now]');
    var priceWasEl = root.querySelector('[data-bbx-price-was]');
    var priceSaveEl = root.querySelector('[data-bbx-price-save]');
    var ctaBtn = root.querySelector('[data-bbx-cta]');
    var ctaText = root.querySelector('[data-bbx-cta-text]');
    var main = root.querySelector('.bbx__main img');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var mainBox = root.querySelector('.bbx__main');

    var qty = 1;
    var idx = 0;

    // ===== Initial selection state (from server-rendered .is-on classes) =====
    var selectedValues = [];
    for (var g = 0; g < optionGroups.length; g++){
      var group = optionGroups[g];
      var oIdx = parseInt(group.dataset.optionIdx, 10);
      var selectedBtn = group.querySelector('[data-value].is-on');
      selectedValues[oIdx] = selectedBtn ? selectedBtn.dataset.value : null;
    }

    function findVariant(sel){
      if (!variants.length) return null;
      // If no options at all (selectedValues empty), return first variant
      if (sel.length === 0) return variants[0];
      for (var i = 0; i < variants.length; i++){
        var v = variants[i];
        var match = true;
        for (var j = 0; j < v.options.length; j++){
          if (v.options[j] !== sel[j]){ match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function render(){
      var v = findVariant(selectedValues);

      // Update form variant ID
      if (v && variantIdInput) variantIdInput.value = String(v.id);

      // Update URL ?variant=ID
      if (v && window.history && window.history.replaceState){
        try {
          var url = new URL(window.location);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(null, '', url);
        } catch(e){}
      }

      // Swap main image to variant's featured_image
      if (v && v.featured_image && main && main.src !== v.featured_image){
        // Same ratio re-point as setSlide(), sourced from the matching thumb.
        // Must run BEFORE main.src is reassigned, or the box holds the old
        // image's height until the new one decodes.
        for (var t0 = 0; t0 < thumbs.length; t0++){
          if (thumbs[t0].dataset.src === v.featured_image){
            var vw = thumbs[t0].dataset.w, vh = thumbs[t0].dataset.h;
            if (vw && vh){ main.setAttribute('width', vw); main.setAttribute('height', vh); }
            break;
          }
        }
        main.src = v.featured_image;
        // Sync gallery idx to that image if it's in the thumb list
        for (var t = 0; t < thumbs.length; t++){
          if (thumbs[t].dataset.src === v.featured_image){
            idx = t;
            for (var tt = 0; tt < thumbs.length; tt++) thumbs[tt].classList.remove('is-on');
            thumbs[t].classList.add('is-on');
            if (countEl) countEl.textContent = (t+1) + ' / ' + thumbs.length;
            break;
          }
        }
      }

      // Update price + savings (multiply by qty)
      var price = v ? v.price : 0;
      var compare = v ? v.compare_at_price : 0;
      var total = price * qty;
      var totalCompare = compare * qty;

      if (priceNowEl) priceNowEl.textContent = fmt(total);

      if (priceWasEl){
        if (compare > price){
          priceWasEl.textContent = fmt(totalCompare);
          priceWasEl.style.display = '';
        } else {
          priceWasEl.textContent = '';
          priceWasEl.style.display = 'none';
        }
      }

      if (priceSaveEl){
        if (compare > price){
          var bbxOvr = parseInt(priceSaveEl.getAttribute('data-bbx-save-override') || '0', 10);
          var savings = (bbxOvr > 0) ? bbxOvr : Math.round((compare - price) / compare * 100);
          priceSaveEl.textContent = 'SAVE ' + savings + '%';
          priceSaveEl.style.display = '';
        } else {
          priceSaveEl.textContent = '';
          priceSaveEl.style.display = 'none';
        }
      }

      // Update CTA (state + label)
      var addLabel = root.dataset.ctaAdd || 'Add to Cart';
      var soldoutLabel = root.dataset.ctaSoldout || 'Sold Out';
      var unavailLabel = root.dataset.ctaUnavailable || 'Unavailable';

      var available = v && v.available;
      if (ctaBtn){
        if (!available){
          ctaBtn.classList.add('is-soldout');
          ctaBtn.disabled = true;
        } else {
          ctaBtn.classList.remove('is-soldout');
          ctaBtn.disabled = false;
        }
      }
      if (ctaText){
        if (!v){
          ctaText.textContent = unavailLabel;
        } else if (!v.available){
          ctaText.textContent = soldoutLabel;
        } else {
          ctaText.textContent = addLabel + ' · ' + fmt(total);
        }
      }

      // Update inline "selected value" display in each variant group label
      for (var i = 0; i < optionGroups.length; i++){
        var group = optionGroups[i];
        var dispEl = group.querySelector('[data-option-value-display]');
        var oIdx = parseInt(group.dataset.optionIdx, 10);
        if (dispEl) dispEl.textContent = selectedValues[oIdx] || '';
      }
    }

    // ===== Bind variant option clicks (swatches + pills) =====
    var optionBtns = root.querySelectorAll('[data-option-idx][data-value]');
    for (var k = 0; k < optionBtns.length; k++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (btn.classList.contains('is-unavailable')) return;
          var oIdx = parseInt(btn.dataset.optionIdx, 10);
          var value = btn.dataset.value;
          selectedValues[oIdx] = value;
          // Toggle is-on among siblings of the same option group
          var siblings = root.querySelectorAll('[data-option-idx="' + oIdx + '"][data-value]');
          for (var s = 0; s < siblings.length; s++) siblings[s].classList.remove('is-on');
          btn.classList.add('is-on');
          render();
        });
      })(optionBtns[k]);
    }

    // ===== Quantity stepper =====
    function setQty(n){
      n = Math.max(1, Math.min(99, parseInt(n, 10) || 1));
      qty = n;
      if (qtyDisplay) qtyDisplay.value = String(n);
      if (qtyHiddenInput) qtyHiddenInput.value = String(n);
      if (qtyMinus) qtyMinus.disabled = n <= 1;
      render();
    }
    if (qtyMinus) qtyMinus.addEventListener('click', function(ev){ ev.preventDefault(); setQty(qty - 1); });
    if (qtyPlus) qtyPlus.addEventListener('click', function(ev){ ev.preventDefault(); setQty(qty + 1); });
    if (qtyDisplay){
      qtyDisplay.addEventListener('change', function(){ setQty(qtyDisplay.value); });
      qtyDisplay.addEventListener('input', function(){
        var v = parseInt(qtyDisplay.value, 10);
        if (!isNaN(v)){ qty = Math.max(1, Math.min(99, v)); if (qtyHiddenInput) qtyHiddenInput.value = String(qty); render(); }
      });
    }

    // ===== Form submit guard =====
    var form = root.querySelector('form[action*="/cart/add"]');
    if (form){
      form.addEventListener('submit', function(ev){
        if (ctaBtn && ctaBtn.disabled){ ev.preventDefault(); }
      });
    }

    // ===== Gallery =====
    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src){
        // Re-point the intrinsic ratio BEFORE swapping src, so the box resizes
        // in one step instead of holding the previous image's height until the
        // new one decodes. Keeps every image at its true shape, uncropped.
        var tw = thumbs[idx].dataset.w, th = thumbs[idx].dataset.h;
        if (tw && th){ main.setAttribute('width', tw); main.setAttribute('height', th); }
        main.src = src;
      }
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try { active.scrollIntoView({behavior:'smooth', block:'nearest', inline:'nearest'}); } catch(e){
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    for (var k2 = 0; k2 < thumbs.length; k2++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault(); ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k2);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // ===== Drag-to-scroll on thumb strip (desktop) =====
    if (thumbsContainer && thumbs.length > 1){
      var tDown=false, tStartX=0, tStartScroll=0, tMoved=false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return;
        tDown = true; tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){ tDown = false; thumbsContainer._bbxDragged = false; }
      });
    }

    // ===== Main image swipe (touch + mouse drag) =====
    if (mainBox && thumbs.length > 1){
      var sx=0, sy=0, swiping=false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = true;
      }, {passive:true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive:true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive:true});

      var mx=0, my=0, mdown=false, mmoved=false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true; mmoved = false; mx = e.clientX; my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    setQty(1);
    render();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buybox-notiers"] && !Shopify.designMode) return;
  try {
    
(function(){
  // Scoped to [data-bbx-notiers] so this never touches a Buy Box v6 section,
  // and keyed on data-bbxn-init so v6's own init flag (shipped as a decoy on
  // this section) cannot make us skip our own boot.
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx[data-bbx-notiers="1"]');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxnInit === '1') continue;
      el.dataset.bbxnInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[bbxn]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var box = root.querySelector('.bbxq');
    var bd  = box ? box.dataset : {};

    var plan   = root.dataset.defaultPlan || 'once';
    var qtyMin = 1;
    var qtyMax = parseInt(bd.qtyMax, 10) || 6;
    if (qtyMax < qtyMin) qtyMax = qtyMin;
    var qty = parseInt(root.dataset.defaultQty || '1', 10);
    if (isNaN(qty)) qty = 1;
    qty = Math.min(qtyMax, Math.max(qtyMin, qty));

    var compareCents = parseInt(bd.compare, 10) || 0;
    var daysPer      = parseInt(bd.daysPerUnit, 10) || 0;
    var unitOne      = bd.unitOne  || 'Bottle';
    var unitMany     = bd.unitMany || 'Bottles';
    var wasPrefix    = bd.wasPrefix || 'was';

    var tplUp     = bd.nudgeUp   || 'Add {n} more {unit} → unlock {pct}% off';
    var tplMax    = bd.nudgeMax  || 'Biggest discount unlocked · {pct}% off every {unit}';
    var tplFlat   = bd.nudgeFlat || '{pct}% off every {unit}';
    var tplSupply = bd.supplyTpl || '{d}-Day Supply';
    var tplSaved  = bd.savedTpl  || 'You save {amt}';
    var subOnce   = bd.ctaSubOnce || 'One-time purchase, no subscription';
    var subSub    = bd.ctaSubSub  || 'Subscription selected · Cancel anytime';

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="bbx-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bbx-cta-sub-"]');

    var numEl      = root.querySelector('.bbxq__num');
    var minusEl    = root.querySelector('.bbxq__step--minus');
    var plusEl     = root.querySelector('.bbxq__step--plus');
    var unitEl     = root.querySelector('[data-unit-out]');
    var offEl      = root.querySelector('[data-off]');
    var nowEl      = root.querySelector('[data-now]');
    var wasEl      = root.querySelector('[data-was]');
    var ladderEl   = root.querySelector('[data-ladder]');
    var nudgeEl    = root.querySelector('[data-nudge]');
    var nudgeTxt   = root.querySelector('[data-nudge-text]');
    var flatEl     = root.querySelector('[data-flat]');
    var supplyEl   = root.querySelector('[data-supply]');
    var totalEl    = root.querySelector('[data-total]');
    var totalWasEl = root.querySelector('[data-total-was]');
    var savedEl    = root.querySelector('[data-saved]');

    function tpl(str, map){
      var out = String(str);
      for (var k in map){
        if (Object.prototype.hasOwnProperty.call(map, k)) out = out.split('{' + k + '}').join(map[k]);
      }
      return out;
    }
    function unitWord(n){ return n === 1 ? unitOne : unitMany; }

    // ---- Discount ladders -------------------------------------------------
    // Rungs come from data-rungN on the container: oncePrice|onceDisc|subPrice|subDisc|subPlanId
    // (no dash before the digit — dataset only camel-cases a dash before a letter)
    // once: always 3 rungs (tier prices always exist)
    // sub : only rungs that actually carry a selling plan, so the price shown
    //       always comes from the same allocation as the plan id we post.
    var RUNG_QTYS = [1, 2, 3];
    function rungs(p){
      var out = [];
      for (var i = 0; i < RUNG_QTYS.length; i++){
        var q   = RUNG_QTYS[i];
        var raw = bd['rung' + q];
        if (!raw) continue;
        var f = String(raw).split('|');
        if (p === 'sub'){
          var sp  = parseInt(f[2], 10) || 0;
          var pid = (f[4] || '').trim();
          if (sp > 0 && pid) out.push({ q:q, price:sp, disc:parseInt(f[3],10)||0, plan:pid });
        } else {
          out.push({ q:q, price:parseInt(f[0],10)||0, disc:parseInt(f[1],10)||0, plan:'' });
        }
      }
      if (!out.length && p === 'sub') return rungs('once');
      return out;
    }
    function pick(list, n){
      var r = list[0];
      for (var i = 0; i < list.length; i++){ if (list[i].q <= n) r = list[i]; }
      return r;
    }
    function bump(el){
      if (!el) return;
      el.classList.remove('is-pop');
      void el.offsetWidth;
      el.classList.add('is-pop');
    }

    var lastTotal = -1;

    function render(skipInput){
      // ---- Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }

      var list = rungs(plan);
      var hit  = pick(list, qty) || { q:1, price:0, disc:0, plan:'' };

      // ---- Stepper
      if (numEl && !skipInput) numEl.value = String(qty);
      if (numEl) numEl.setAttribute('aria-valuenow', String(qty));
      if (minusEl) minusEl.disabled = qty <= qtyMin;
      if (plusEl)  plusEl.disabled  = qty >= qtyMax;
      if (unitEl)  unitEl.textContent = unitWord(qty);

      // ---- Unit price
      if (offEl){
        offEl.textContent = hit.disc + '% OFF';
        offEl.style.display = hit.disc > 0 ? '' : 'none';
      }
      if (nowEl) nowEl.textContent = fmt(hit.price);
      if (wasEl){
        wasEl.textContent = wasPrefix + ' ' + fmt(compareCents);
        wasEl.style.display = compareCents > hit.price ? '' : 'none';
      }

      // ---- Is there actually a volume ladder to talk about?
      var maxDisc = 0, minDisc = -1;
      for (var t2 = 0; t2 < list.length; t2++){
        var rd = list[t2].disc;
        if (rd > maxDisc) maxDisc = rd;
        if (minDisc < 0 || rd < minDisc) minDisc = rd;
      }
      if (ladderEl){
        ladderEl.classList.toggle('is-flat', maxDisc === minDisc);
        ladderEl.classList.toggle('is-off', maxDisc <= 0);
      }
      if (flatEl) flatEl.textContent = tpl(tplFlat, { pct:maxDisc, unit:unitOne });

      // ---- Next-rung nudge
      var next = null;
      for (var n2 = 0; n2 < list.length; n2++){
        if (list[n2].q > qty && list[n2].disc > hit.disc){ next = list[n2]; break; }
      }
      if (nudgeEl){
        if (next && next.q <= qtyMax){
          var need = next.q - qty;
          nudgeEl.classList.remove('is-max');
          nudgeEl.disabled = false;
          nudgeEl.dataset.jump = String(next.q);
          if (nudgeTxt) nudgeTxt.textContent = tpl(tplUp, { n:need, unit:unitWord(need), pct:next.disc });
        } else {
          nudgeEl.classList.add('is-max');
          nudgeEl.disabled = true;
          nudgeEl.dataset.jump = '0';
          if (nudgeTxt) nudgeTxt.textContent = tpl(tplMax, { pct:hit.disc, unit:unitOne });
        }
      }

      // ---- Totals
      var total    = hit.price * qty;
      var cmpTotal = compareCents * qty;
      var saved    = cmpTotal - total;
      if (totalEl) totalEl.textContent = fmt(total);
      if (totalWasEl){
        totalWasEl.textContent = fmt(cmpTotal);
        totalWasEl.style.display = saved > 0 ? '' : 'none';
      }
      if (savedEl){
        if (saved > 0 && cmpTotal > 0){
          savedEl.textContent = tpl(tplSaved, { amt: fmt(saved), pct: Math.round(saved * 100 / cmpTotal) });
          savedEl.style.display = '';
        } else {
          savedEl.style.display = 'none';
        }
      }
      var supplyStr = '';
      if (daysPer > 0) supplyStr = tpl(tplSupply, { d: qty * daysPer });
      if (supplyEl) supplyEl.textContent = qty + ' ' + unitWord(qty) + (supplyStr ? ' · ' + supplyStr : '');

      // ---- Form inputs (this is what actually goes to cart)
      if (qtyInput)  qtyInput.value  = String(qty);
      if (planInput) planInput.value = (plan === 'sub') ? (hit.plan || '') : '';

      // ---- CTA label + subline
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      if (ctaText) ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(total);
      if (ctaSub)  ctaSub.textContent  = (supplyStr ? supplyStr + ' · ' : '') + (plan === 'sub' ? subSub : subOnce);

      if (lastTotal !== -1 && lastTotal !== total){ bump(nowEl); bump(totalEl); }
      lastTotal = total;
    }

    // ---- Quantity events --------------------------------------------------
    function setQty(n, skipInput){
      var v = parseInt(n, 10);
      if (isNaN(v)) v = qtyMin;
      qty = Math.min(qtyMax, Math.max(qtyMin, v));
      render(skipInput);
    }
    if (minusEl) minusEl.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setQty(qty - 1); });
    if (plusEl)  plusEl.addEventListener('click',  function(ev){ ev.preventDefault(); ev.stopPropagation(); setQty(qty + 1); });

    if (numEl){
      numEl.addEventListener('input', function(){
        var raw = numEl.value.replace(/[^0-9]/g, '');
        if (raw !== numEl.value) numEl.value = raw;
        if (raw === '') return;
        var v = parseInt(raw, 10);
        // Live-update only while the typed value is already valid — clamping
        // mid-keystroke would fight the cursor.
        if (!isNaN(v) && v >= qtyMin && v <= qtyMax){ qty = v; render(true); }
      });
      numEl.addEventListener('change', function(){ setQty(numEl.value); });
      numEl.addEventListener('blur',   function(){ setQty(numEl.value); });
      numEl.addEventListener('focus',  function(){ try { numEl.select(); } catch (e) {} });
      numEl.addEventListener('keydown', function(ev){
        if (ev.key === 'Enter'){ ev.preventDefault(); setQty(numEl.value); numEl.blur(); }
        else if (ev.key === 'ArrowUp'){ ev.preventDefault(); setQty(qty + 1); }
        else if (ev.key === 'ArrowDown'){ ev.preventDefault(); setQty(qty - 1); }
      });
    }

    if (nudgeEl){
      nudgeEl.addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        var j = parseInt(nudgeEl.dataset.jump, 10);
        if (!isNaN(j) && j > 0) setQty(j);
      });
    }

    // ---- Plan cards ------------------------------------------------------
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }

    // ---- Gallery (unchanged from v6) -------------------------------------
    var mainBox = root.querySelector('.bbx__main');
    var main = root.querySelector('.bbx__main img');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next2 = root.querySelector('[id^="bbx-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next2) next2.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._bbxDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buybox-v4"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows   = root.querySelectorAll('.bbx__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="bbx-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bbx-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.bbx__qty-row[data-qty="2"] .bbx__qty-extra');

    function getActiveQtyRow(){
      return root.querySelector('.bbx__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bbx__qty-now');
        var saveEl  = b.querySelector('.bbx__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
      }
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Subscription selected · Cancel anytime';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no subscription';
        }
      }
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // Gallery
    var mainBox = root.querySelector('.bbx__main');
    var main = root.querySelector('.bbx__main img');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._bbxDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buybox-v6-meth72-up"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows   = root.querySelectorAll('.bbx__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="bbx-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bbx-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.bbx__qty-row[data-qty="2"] .bbx__qty-extra');

    function getActiveQtyRow(){
      return root.querySelector('.bbx__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bbx__qty-now');
        var saveEl  = b.querySelector('.bbx__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
      }
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Subscription selected · Cancel anytime';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no subscription';
        }
      }
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // ==================================================================
    // IODINE UPSELL + AJAX CART
    //
    // A Shopify product form posts exactly ONE variant, so the moment a
    // second product is involved the submit has to go through /cart/add.js
    // with an items array. Every failure path below still ends in a real
    // add: a rejected request retries without the add-on, and if that also
    // fails it falls through to the native form post. A customer must never
    // click Add to Cart and end up with nothing in it.
    // ==================================================================
    var form    = root.querySelector('form[id^="bbx-form-"]');
    // 'button.bbx__cta', NOT '[id^="bbx-cta-"]' — the prefix selector also
    // matches bbx-cta-text-* and bbx-cta-sub-*, so it would return the label
    // span instead of the button and every disable/enable would silently no-op.
    var ctaBtn  = root.querySelector('button.bbx__cta');
    var upBox   = root.querySelector('[data-mru72]');
    var upCb    = root.querySelector('[data-mru72-toggle]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;

    function upsellWanted(){
      return !!(upBox && upCb && upCb.checked && !upBox.classList.contains('is-off'));
    }

    // Make declining VISIBLE. The card is pre-checked, so if the two states
    // look alike the customer cannot tell whether the add-on is in their
    // order — which reads as a dark pattern and costs the sale either way.
    // 'is-declined' is purely cosmetic; 'is-off' still means hidden.
    // The toggle itself is native (the whole card is the <label>), so this
    // listener only mirrors state — it never drives it.
    // Match the BOTTLE's height to the copy column beside it — top edge level
    // with the title's top, bottom edge level with the YOU SAVE badge's bottom.
    // Done in JS because CSS cannot derive one element's height from a
    // sibling's. The only pure-CSS route is stretching the copy column to the
    // image instead, which moves the text — not what was asked for. Nothing
    // here touches the copy's spacing; it only ever resizes the image.
    //
    // The CSS height is the no-JS fallback. It carries !important, so the
    // inline override MUST be set with priority or it silently loses.
    var upCopy = upBox && upBox.querySelector('.mru72__copy');
    var upImg  = upBox && upBox.querySelector('.mru72__media img');
    function syncUpsellMediaHeight(){
      if (!upCopy || !upImg) return;
      var h = upCopy.getBoundingClientRect().height;
      if (h <= 0) return;
      // Only write on a real change — guards against a ResizeObserver loop.
      if (Math.abs(parseFloat(upImg.style.height || '0') - h) < 0.5) return;
      upImg.style.setProperty('height', h + 'px', 'important');
    }
    if (upCopy && upImg){
      // Debounced with a self-clearing timeout, NOT a rAF guard flag.
      // A `if (pending) return;` gate around requestAnimationFrame deadlocks
      // permanently the moment one rAF callback fails to run — which happens
      // whenever the page is not considered visible (background tab, embedded
      // preview pane), because rAF is throttled there while timers still fire.
      // The flag then stays set and every future resize is silently dropped.
      // clearTimeout+reassign has no such trap: the latest call always wins.
      var upTimer = 0;
      function scheduleUpsellSync(){
        if (upTimer) clearTimeout(upTimer);
        upTimer = setTimeout(function(){
          upTimer = 0; syncUpsellMediaHeight();
        }, 40);
      }

      syncUpsellMediaHeight();

      // Bind resize ALWAYS — never treat ResizeObserver as sufficient.
      // Verified on this storefront: ResizeObserver exists but never fires,
      // not even the guaranteed initial callback, because a third-party
      // script has stubbed it. The old code only attached this listener when
      // ResizeObserver was ABSENT, so on this store nothing ever re-ran and
      // the bottle stayed frozen at its first-paint height while the copy
      // reflowed around it. Treat RO as a bonus, not the mechanism.
      window.addEventListener('resize', scheduleUpsellSync);
      window.addEventListener('orientationchange', scheduleUpsellSync);
      if (window.ResizeObserver){
        try { new ResizeObserver(scheduleUpsellSync).observe(upCopy); } catch (e) {}
      }

      // The webfont swap changes the copy's height after first paint.
      if (document.fonts && document.fonts.ready){
        document.fonts.ready.then(syncUpsellMediaHeight).catch(function(){});
      }
      // Late reflow catch-all: font swap, lazily-loaded media above the card,
      // and app scripts that inject content after load all move the copy.
      var upDelays = [120, 400, 1200, 2500];
      for (var d = 0; d < upDelays.length; d++) setTimeout(syncUpsellMediaHeight, upDelays[d]);

      // Event-independent backstop. Neither ResizeObserver nor the window
      // 'resize' event can be relied on here: RO is stubbed by a third-party
      // script on this storefront, and some embedded/preview viewports change
      // width without emitting 'resize' at all. Both were verified dead on
      // this page. So poll briefly and cheaply instead of trusting either.
      // syncUpsellMediaHeight early-returns when already within 0.5px, so a
      // steady-state tick is one getBoundingClientRect and nothing else.
      // Self-terminating: 30 ticks x 500ms = 15s, which comfortably covers
      // font swap, lazy media above the card, and late app injection. After
      // that the resize listener handles real user resizes in a real browser.
      var upPolls = 0;
      var upPoll = setInterval(function(){
        syncUpsellMediaHeight();
        if (++upPolls >= 30) clearInterval(upPoll);
      }, 500);
    }

    function syncUpsellState(){
      if (!upBox || !upCb) return;
      upBox.classList.toggle('is-declined', !upCb.checked);
    }
    if (upCb){
      upCb.addEventListener('change', syncUpsellState);
      syncUpsellState();
    }

    function openCartDrawer(){
      // Verified against the live AJ storefront: UpCart V2 exposes
      // upcartRefreshCart and upcartOpenCart as TOP-LEVEL window functions,
      // not as methods on window.upcart. Refresh before opening or the drawer
      // paints its preloaded snapshot and the lines we just added are missing.
      try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
      try {
        if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
        else if (window.upcart && typeof window.upcart.openCart === 'function') window.upcart.openCart();
      } catch (e) {}
      // Theme-native fallbacks, for any theme where UpCart is absent.
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
        document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
      } catch (e) {}
      var trigger = document.querySelector('#upcart-cart-trigger,.upcart-trigger,[data-upcart-open]');
      if (trigger){ try { trigger.click(); } catch (e) {} }
      var dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && typeof dawnDrawer.open === 'function'){ try { dawnDrawer.open(); } catch (e) {} }

      // Verify, then fall back. No drawer after ~1s means there is no drawer.
      setTimeout(function(){
        var opened = document.body.classList.contains('upcartPopupShow') ||
                     document.body.classList.contains('upcart-open') ||
                     !!document.querySelector('cart-drawer.active, .drawer.active, #CartDrawer.active');
        if (!opened) window.location.href = '/cart';
      }, 1000);
    }

    function postItems(items){
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: items})
      }).then(function(r){
        if (!r.ok){
          return r.json().catch(function(){ return {}; }).then(function(b){
            var err = new Error('cart/add failed');
            err.status = r.status;
            err.body = b;
            throw err;
          });
        }
        return r.json();
      });
    }

    // Tell UpCart to keep its hands off this buy box.
    //
    // upcartShouldSkipAddToCart is UpCart's own documented opt-out hook
    // (it ships as `e => false`). CHAIN it rather than replace it: anything
    // originating inside a .bbx section is ours to handle, everything else
    // falls through to whatever UpCart or another section already installed,
    // so no other add-to-cart on the page changes behaviour. Installed once
    // per page, not once per section. This is the belt to the type="button"
    // braces above — either alone is sufficient.
    if (!window.__bbxUpcartHooked){
      window.__bbxUpcartHooked = true;
      var priorSkip = window.upcartShouldSkipAddToCart;
      window.upcartShouldSkipAddToCart = function(ev){
        try {
          var t = ev && (ev.target || ev.srcElement);
          if (t && t.closest && t.closest('.bbx')) return true;
        } catch (e) {}
        try { return typeof priorSkip === 'function' ? priorSkip(ev) : false; }
        catch (e) { return false; }
      };
    }

    // The add itself. Shared by the CTA click and the Enter-key guard.
    function doAddToCart(){
      // No fetch = ancient browser. form.submit() is a real browser POST and
      // fires no submit listeners, so nothing can intercept it either.
      if (typeof window.fetch !== 'function'){ if (form) form.submit(); return; }

      var mainId = idInput && idInput.value;
      if (!mainId){ if (form) form.submit(); return; }

      var mainItem = {id: parseInt(mainId, 10), quantity: qty};
      if (planInput && planInput.value) mainItem.selling_plan = planInput.value;

      var items = [mainItem];
      var addOn = null;
      if (upsellWanted()){
        var upId = parseInt(upBox.getAttribute('data-mru72-variant'), 10);
        if (upId){
          addOn = {id: upId, quantity: 1};
          // Attribution rides ON the add-on line, never on the cart. It therefore
          // survives exactly as long as the line does: rejected on add, or removed
          // in the drawer, means no property and so no order tag. Hidden from the
          // customer by the leading underscore; still readable by Flow and the API.
          var upSrc = (upBox.getAttribute('data-mru72-source') || '').trim();
          if (upSrc){ addOn.properties = {'_upsell_source': upSrc}; }
          items.push(addOn);
        }
      }

      if (ctaBtn){ ctaBtn.disabled = true; ctaBtn.style.opacity = '.72'; }
      function release(){ if (ctaBtn){ ctaBtn.disabled = false; ctaBtn.style.opacity = ''; } }

      postItems(items)
        .then(function(){ release(); openCartDrawer(); })
        .catch(function(){
          // The add-on is the fragile line: it is Locksmith-locked and it is
          // oversold. Never let it take the main product down with it.
          if (!addOn){ release(); if (form) form.submit(); return; }
          postItems([mainItem])
            .then(function(){
              release();
              if (upCb) upCb.checked = false;
              openCartDrawer();
            })
            .catch(function(){ release(); if (form) form.submit(); });
        });
    }

    if (ctaBtn){
      ctaBtn.addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        doAddToCart();
      });
    }

    // Enter inside the form still raises a submit even with no submit button.
    // Catch it in the CAPTURE phase so we beat any cart app listening on bubble.
    if (form){
      form.addEventListener('submit', function(ev){
        ev.preventDefault();
        ev.stopImmediatePropagation();
        doAddToCart();
      }, true);
    }

    // Gallery
    var mainBox = root.querySelector('.bbx__main');
    var main = root.querySelector('.bbx__main img');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src){
        // Re-point the intrinsic ratio BEFORE swapping src, so the box resizes
        // in one step instead of holding the previous image's height until the
        // new one decodes. Keeps every image at its true shape, uncropped.
        var tw = thumbs[idx].dataset.w, th = thumbs[idx].dataset.h;
        if (tw && th){ main.setAttribute('width', tw); main.setAttribute('height', th); }
        main.src = src;
      }
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._bbxDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buybox-v6-meth72"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows   = root.querySelectorAll('.bbx__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="bbx-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bbx-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.bbx__qty-row[data-qty="2"] .bbx__qty-extra');

    function getActiveQtyRow(){
      return root.querySelector('.bbx__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bbx__qty-now');
        var saveEl  = b.querySelector('.bbx__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
      }
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Subscription selected · Cancel anytime';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no subscription';
        }
      }
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // Gallery
    var mainBox = root.querySelector('.bbx__main');
    var main = root.querySelector('.bbx__main img');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src){
        // Re-point the intrinsic ratio BEFORE swapping src, so the box resizes
        // in one step instead of holding the previous image's height until the
        // new one decodes. Keeps every image at its true shape, uncropped.
        var tw = thumbs[idx].dataset.w, th = thumbs[idx].dataset.h;
        if (tw && th){ main.setAttribute('width', tw); main.setAttribute('height', th); }
        main.src = src;
      }
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._bbxDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buybox-v6-storeB-cards"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbxc');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxcInit === '1') continue;
      el.dataset.bbxcInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[bbxc]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.bbxc__plan-card');
    var qtyRows   = root.querySelectorAll('.bbxc__card');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="bbxc-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bbxc-cta-sub-"]');

    // Summary bar — the only place a dollar total is shown
    var totalLabel  = root.querySelector('.bbxc__total-label');
    var totalDesc   = root.querySelector('.bbxc__total-desc');
    var totalNow    = root.querySelector('.bbxc__total-now');
    var totalWas    = root.querySelector('.bbxc__total-was');
    var wasPrefix   = root.dataset.wasPrefix || 'was';
    var savePrefix  = root.dataset.savePrefix || 'Save';
    var unitCompare = parseInt(root.dataset.compareCents || '0', 10) || 0;

    function getActiveQtyRow(){
      return root.querySelector('.bbxc__card.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bbxc__each');
        var saveEl  = b.querySelector('.bbxc__off');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = savePrefix + ' ' + disc + '%';
      }


      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;

      // Summary bar
      if (totalNow) totalNow.textContent = fmt(totalCents);
      if (totalWas){
        var wasCents = unitCompare * qty;
        if (unitCompare > 0 && wasCents > totalCents){
          totalWas.textContent = wasPrefix + ' ' + fmt(wasCents);
          totalWas.style.display = '';
        } else {
          totalWas.style.display = 'none';
        }
      }
      if (totalLabel){
        var lblOnce = totalLabel.getAttribute('data-label-once') || 'Your Total Today';
        var lblSub  = totalLabel.getAttribute('data-label-sub')  || 'Your First Payment';
        totalLabel.textContent = plan === 'sub' ? lblSub : lblOnce;
      }
      if (totalDesc){
        var dNoun   = activeRow.dataset.noun   || '';
        var dSupply = activeRow.dataset.supply || '';
        totalDesc.textContent = qty + ' ' + dNoun + (dSupply ? ' · ' + dSupply : '');
      }
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
      }
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Subscription selected · Cancel anytime';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no subscription';
        }
      }
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // Gallery
    var mainBox = root.querySelector('.bbxc__main');
    var main = root.querySelector('.bbxc__main img');
    var countEl = root.querySelector('[id^="bbxc-count-"]');
    var thumbsContainer = root.querySelector('.bbxc__thumbs');
    var thumbs = root.querySelectorAll('.bbxc__thumb');
    var prev = root.querySelector('[id^="bbxc-prev-"]');
    var next = root.querySelector('[id^="bbxc-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxcDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxcDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._bbxcDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._bbxcDragged = false; }, 100);
        } else {
          thumbsContainer._bbxcDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._bbxcDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buybox-v6-storeB"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows   = root.querySelectorAll('.bbx__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="bbx-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bbx-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.bbx__qty-row[data-qty="2"] .bbx__qty-extra');

    function getActiveQtyRow(){
      return root.querySelector('.bbx__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bbx__qty-now');
        var saveEl  = b.querySelector('.bbx__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
      }
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Subscription selected · Cancel anytime';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no subscription';
        }
      }
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // Gallery
    var mainBox = root.querySelector('.bbx__main');
    var main = root.querySelector('.bbx__main img');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src){
        // Re-point the intrinsic ratio BEFORE swapping src, so the box resizes
        // in one step instead of holding the previous image's height until the
        // new one decodes. Keeps every image at its true shape, uncropped.
        var tw = thumbs[idx].dataset.w, th = thumbs[idx].dataset.h;
        if (tw && th){ main.setAttribute('width', tw); main.setAttribute('height', th); }
        main.src = src;
      }
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._bbxDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buybox-v6"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows   = root.querySelectorAll('.bbx__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="bbx-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bbx-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.bbx__qty-row[data-qty="2"] .bbx__qty-extra');

    function getActiveQtyRow(){
      return root.querySelector('.bbx__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bbx__qty-now');
        var saveEl  = b.querySelector('.bbx__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
      }
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Subscription selected · Cancel anytime';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no subscription';
        }
      }
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // Gallery
    var mainBox = root.querySelector('.bbx__main');
    var main = root.querySelector('.bbx__main img');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._bbxDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colostrum-buy-box"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows   = root.querySelectorAll('.bbx__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="bbx-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bbx-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.bbx__qty-row[data-qty="2"] .bbx__qty-extra');

    function getActiveQtyRow(){
      return root.querySelector('.bbx__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bbx__qty-now');
        var saveEl  = b.querySelector('.bbx__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
      }
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Subscription selected · Cancel anytime';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no subscription';
        }
      }
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // Gallery
    var mainBox = root.querySelector('.bbx__main');
    var main = root.querySelector('.bbx__main img');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._bbxDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zz-cand-a"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.mbc');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.mbcInit === '1') continue;
      el.dataset.mbcInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[mbc]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.mbc__plan-card');
    var qtyRows   = root.querySelectorAll('.mbc__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="mbc-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="mbc-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.mbc__qty-row[data-qty="2"] .mbc__qty-extra');

    function getActiveQtyRow(){
      return root.querySelector('.mbc__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.mbc__qty-now');
        var saveEl  = b.querySelector('.mbc__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
      }
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Subscription selected · Cancel anytime';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no subscription';
        }
      }
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // ==================================================================
    // IODINE UPSELL + AJAX CART
    //
    // A Shopify product form posts exactly ONE variant, so the moment a
    // second product is involved the submit has to go through /cart/add.js
    // with an items array. Every failure path below still ends in a real
    // add: a rejected request retries without the add-on, and if that also
    // fails it falls through to the native form post. A customer must never
    // click Add to Cart and end up with nothing in it.
    // ==================================================================
    var form    = root.querySelector('form[id^="mbc-form-"]');
    // 'button.mbc__cta', NOT '[id^="mbc-cta-"]' — the prefix selector also
    // matches mbc-cta-text-* and mbc-cta-sub-*, so it would return the label
    // span instead of the button and every disable/enable would silently no-op.
    var ctaBtn  = root.querySelector('button.mbc__cta');
    var upBox   = root.querySelector('[data-mbcup]');
    var upCb    = root.querySelector('[data-mbcup-toggle]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;

    function upsellWanted(){
      return !!(upBox && upCb && upCb.checked && !upBox.classList.contains('is-off'));
    }

    // Make declining VISIBLE. The card is pre-checked, so if the two states
    // look alike the customer cannot tell whether the add-on is in their
    // order — which reads as a dark pattern and costs the sale either way.
    // 'is-declined' is purely cosmetic; 'is-off' still means hidden.
    // The toggle itself is native (the whole card is the <label>), so this
    // listener only mirrors state — it never drives it.
    // Match the BOTTLE's height to the copy column beside it — top edge level
    // with the title's top, bottom edge level with the YOU SAVE badge's bottom.
    // Done in JS because CSS cannot derive one element's height from a
    // sibling's. The only pure-CSS route is stretching the copy column to the
    // image instead, which moves the text — not what was asked for. Nothing
    // here touches the copy's spacing; it only ever resizes the image.
    //
    // The CSS height is the no-JS fallback. It carries !important, so the
    // inline override MUST be set with priority or it silently loses.
    var upCopy = upBox && upBox.querySelector('.mbcup__copy');
    var upImg  = upBox && upBox.querySelector('.mbcup__media img');
    function syncUpsellMediaHeight(){
      if (!upCopy || !upImg) return;
      var h = upCopy.getBoundingClientRect().height;
      if (h <= 0) return;
      // Only write on a real change — guards against a ResizeObserver loop.
      if (Math.abs(parseFloat(upImg.style.height || '0') - h) < 0.5) return;
      upImg.style.setProperty('height', h + 'px', 'important');
    }
    if (upCopy && upImg){
      // Debounced with a self-clearing timeout, NOT a rAF guard flag.
      // A `if (pending) return;` gate around requestAnimationFrame deadlocks
      // permanently the moment one rAF callback fails to run — which happens
      // whenever the page is not considered visible (background tab, embedded
      // preview pane), because rAF is throttled there while timers still fire.
      // The flag then stays set and every future resize is silently dropped.
      // clearTimeout+reassign has no such trap: the latest call always wins.
      var upTimer = 0;
      function scheduleUpsellSync(){
        if (upTimer) clearTimeout(upTimer);
        upTimer = setTimeout(function(){
          upTimer = 0; syncUpsellMediaHeight();
        }, 40);
      }

      syncUpsellMediaHeight();

      // Bind resize ALWAYS — never treat ResizeObserver as sufficient.
      // Verified on this storefront: ResizeObserver exists but never fires,
      // not even the guaranteed initial callback, because a third-party
      // script has stubbed it. The old code only attached this listener when
      // ResizeObserver was ABSENT, so on this store nothing ever re-ran and
      // the bottle stayed frozen at its first-paint height while the copy
      // reflowed around it. Treat RO as a bonus, not the mechanism.
      window.addEventListener('resize', scheduleUpsellSync);
      window.addEventListener('orientationchange', scheduleUpsellSync);
      if (window.ResizeObserver){
        try { new ResizeObserver(scheduleUpsellSync).observe(upCopy); } catch (e) {}
      }

      // The webfont swap changes the copy's height after first paint.
      if (document.fonts && document.fonts.ready){
        document.fonts.ready.then(syncUpsellMediaHeight).catch(function(){});
      }
      // Late reflow catch-all: font swap, lazily-loaded media above the card,
      // and app scripts that inject content after load all move the copy.
      var upDelays = [120, 400, 1200, 2500];
      for (var d = 0; d < upDelays.length; d++) setTimeout(syncUpsellMediaHeight, upDelays[d]);

      // Event-independent backstop. Neither ResizeObserver nor the window
      // 'resize' event can be relied on here: RO is stubbed by a third-party
      // script on this storefront, and some embedded/preview viewports change
      // width without emitting 'resize' at all. Both were verified dead on
      // this page. So poll briefly and cheaply instead of trusting either.
      // syncUpsellMediaHeight early-returns when already within 0.5px, so a
      // steady-state tick is one getBoundingClientRect and nothing else.
      // Self-terminating: 30 ticks x 500ms = 15s, which comfortably covers
      // font swap, lazy media above the card, and late app injection. After
      // that the resize listener handles real user resizes in a real browser.
      var upPolls = 0;
      var upPoll = setInterval(function(){
        syncUpsellMediaHeight();
        if (++upPolls >= 30) clearInterval(upPoll);
      }, 500);
    }

    function syncUpsellState(){
      if (!upBox || !upCb) return;
      upBox.classList.toggle('is-declined', !upCb.checked);
    }
    if (upCb){
      upCb.addEventListener('change', syncUpsellState);
      syncUpsellState();
    }

    function openCartDrawer(){
      // Verified against the live AJ storefront: UpCart V2 exposes
      // upcartRefreshCart and upcartOpenCart as TOP-LEVEL window functions,
      // not as methods on window.upcart. Refresh before opening or the drawer
      // paints its preloaded snapshot and the lines we just added are missing.
      try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
      try {
        if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
        else if (window.upcart && typeof window.upcart.openCart === 'function') window.upcart.openCart();
      } catch (e) {}
      // Theme-native fallbacks, for any theme where UpCart is absent.
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
        document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
      } catch (e) {}
      var trigger = document.querySelector('#upcart-cart-trigger,.upcart-trigger,[data-upcart-open]');
      if (trigger){ try { trigger.click(); } catch (e) {} }
      var dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && typeof dawnDrawer.open === 'function'){ try { dawnDrawer.open(); } catch (e) {} }

      // Verify, then fall back. No drawer after ~1s means there is no drawer.
      setTimeout(function(){
        var opened = document.body.classList.contains('upcartPopupShow') ||
                     document.body.classList.contains('upcart-open') ||
                     !!document.querySelector('cart-drawer.active, .drawer.active, #CartDrawer.active');
        if (!opened) window.location.href = '/cart';
      }, 1000);
    }

    function postItems(items){
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: items})
      }).then(function(r){
        if (!r.ok){
          return r.json().catch(function(){ return {}; }).then(function(b){
            var err = new Error('cart/add failed');
            err.status = r.status;
            err.body = b;
            throw err;
          });
        }
        return r.json();
      });
    }

    // Tell UpCart to keep its hands off this buy box.
    //
    // upcartShouldSkipAddToCart is UpCart's own documented opt-out hook
    // (it ships as `e => false`). CHAIN it rather than replace it: anything
    // originating inside a .mbc section is ours to handle, everything else
    // falls through to whatever UpCart or another section already installed,
    // so no other add-to-cart on the page changes behaviour. Installed once
    // per page, not once per section. This is the belt to the type="button"
    // braces above — either alone is sufficient.
    if (!window.__mbcUpcartHooked){
      window.__mbcUpcartHooked = true;
      var priorSkip = window.upcartShouldSkipAddToCart;
      window.upcartShouldSkipAddToCart = function(ev){
        try {
          var t = ev && (ev.target || ev.srcElement);
          if (t && t.closest && t.closest('.mbc')) return true;
        } catch (e) {}
        try { return typeof priorSkip === 'function' ? priorSkip(ev) : false; }
        catch (e) { return false; }
      };
    }

    // The add itself. Shared by the CTA click and the Enter-key guard.
    function doAddToCart(){
      // No fetch = ancient browser. form.submit() is a real browser POST and
      // fires no submit listeners, so nothing can intercept it either.
      if (typeof window.fetch !== 'function'){ if (form) form.submit(); return; }

      var mainId = idInput && idInput.value;
      if (!mainId){ if (form) form.submit(); return; }

      var mainItem = {id: parseInt(mainId, 10), quantity: qty};
      if (planInput && planInput.value) mainItem.selling_plan = planInput.value;

      var items = [mainItem];
      var addOn = null;
      if (upsellWanted()){
        var upId = parseInt(upBox.getAttribute('data-mbcup-variant'), 10);
        if (upId){
          addOn = {id: upId, quantity: 1};
          // Attribution rides ON the add-on line, never on the cart. It therefore
          // survives exactly as long as the line does: rejected on add, or removed
          // in the drawer, means no property and so no order tag. Hidden from the
          // customer by the leading underscore; still readable by Flow and the API.
          var upSrc = (upBox.getAttribute('data-mbcup-source') || '').trim();
          if (upSrc){ addOn.properties = {'_upsell_source': upSrc}; }
          items.push(addOn);
        }
      }

      if (ctaBtn){ ctaBtn.disabled = true; ctaBtn.style.opacity = '.72'; }
      function release(){ if (ctaBtn){ ctaBtn.disabled = false; ctaBtn.style.opacity = ''; } }

      postItems(items)
        .then(function(){ release(); openCartDrawer(); })
        .catch(function(){
          // The add-on is the fragile line: it is Locksmith-locked and it is
          // oversold. Never let it take the main product down with it.
          if (!addOn){ release(); if (form) form.submit(); return; }
          postItems([mainItem])
            .then(function(){
              release();
              if (upCb) upCb.checked = false;
              openCartDrawer();
            })
            .catch(function(){ release(); if (form) form.submit(); });
        });
    }

    if (ctaBtn){
      ctaBtn.addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        doAddToCart();
      });
    }

    // Enter inside the form still raises a submit even with no submit button.
    // Catch it in the CAPTURE phase so we beat any cart app listening on bubble.
    if (form){
      form.addEventListener('submit', function(ev){
        ev.preventDefault();
        ev.stopImmediatePropagation();
        doAddToCart();
      }, true);
    }

    // Gallery
    var mainBox = root.querySelector('.mbc__main');
    var main = root.querySelector('.mbc__main img');
    var countEl = root.querySelector('[id^="mbc-count-"]');
    var thumbsContainer = root.querySelector('.mbc__thumbs');
    var thumbs = root.querySelectorAll('.mbc__thumb');
    var prev = root.querySelector('[id^="mbc-prev-"]');
    var next = root.querySelector('[id^="mbc-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src){
        // Re-point the intrinsic ratio BEFORE swapping src, so the box resizes
        // in one step instead of holding the previous image's height until the
        // new one decodes. Keeps every image at its true shape, uncropped.
        var tw = thumbs[idx].dataset.w, th = thumbs[idx].dataset.h;
        if (tw && th){ main.setAttribute('width', tw); main.setAttribute('height', th); }
        main.src = src;
      }
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._mbcDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._mbcDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._mbcDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._mbcDragged = false; }, 100);
        } else {
          thumbsContainer._mbcDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._mbcDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zz-cand-b"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.mbc');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.mbcInit === '1') continue;
      el.dataset.mbcInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[mbc]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.mbc__plan-card');
    var qtyRows   = root.querySelectorAll('.mbc__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="mbc-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="mbc-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.mbc__qty-row[data-qty="2"] .mbc__qty-extra');

    function getActiveQtyRow(){
      return root.querySelector('.mbc__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.mbc__qty-now');
        var saveEl  = b.querySelector('.mbc__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
      }
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Subscription selected · Cancel anytime';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no subscription';
        }
      }
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // ==================================================================
    // IODINE UPSELL + AJAX CART
    //
    // A Shopify product form posts exactly ONE variant, so the moment a
    // second product is involved the submit has to go through /cart/add.js
    // with an items array. Every failure path below still ends in a real
    // add: a rejected request retries without the add-on, and if that also
    // fails it falls through to the native form post. A customer must never
    // click Add to Cart and end up with nothing in it.
    // ==================================================================
    var form    = root.querySelector('form[id^="mbc-form-"]');
    // 'button.mbc__cta', NOT '[id^="mbc-cta-"]' — the prefix selector also
    // matches mbc-cta-text-* and mbc-cta-sub-*, so it would return the label
    // span instead of the button and every disable/enable would silently no-op.
    var ctaBtn  = root.querySelector('button.mbc__cta');
    var upBox   = root.querySelector('[data-mbcup]');
    var upCb    = root.querySelector('[data-mbcup-toggle]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;

    function upsellWanted(){
      return !!(upBox && upCb && upCb.checked && !upBox.classList.contains('is-off'));
    }

    // Make declining VISIBLE. The card is pre-checked, so if the two states
    // look alike the customer cannot tell whether the add-on is in their
    // order — which reads as a dark pattern and costs the sale either way.
    // 'is-declined' is purely cosmetic; 'is-off' still means hidden.
    // The toggle itself is native (the whole card is the <label>), so this
    // listener only mirrors state — it never drives it.
    // Match the BOTTLE's height to the copy column beside it — top edge level
    // with the title's top, bottom edge level with the YOU SAVE badge's bottom.
    // Done in JS because CSS cannot derive one element's height from a
    // sibling's. The only pure-CSS route is stretching the copy column to the
    // image instead, which moves the text — not what was asked for. Nothing
    // here touches the copy's spacing; it only ever resizes the image.
    //
    // The CSS height is the no-JS fallback. It carries !important, so the
    // inline override MUST be set with priority or it silently loses.
    var upCopy = upBox && upBox.querySelector('.mbcup__copy');
    var upImg  = upBox && upBox.querySelector('.mbcup__media img');
    function syncUpsellMediaHeight(){
      if (!upCopy || !upImg) return;
      var h = upCopy.getBoundingClientRect().height;
      if (h <= 0) return;
      // Only write on a real change — guards against a ResizeObserver loop.
      if (Math.abs(parseFloat(upImg.style.height || '0') - h) < 0.5) return;
      upImg.style.setProperty('height', h + 'px', 'important');
    }
    if (upCopy && upImg){
      // Debounced with a self-clearing timeout, NOT a rAF guard flag.
      // A `if (pending) return;` gate around requestAnimationFrame deadlocks
      // permanently the moment one rAF callback fails to run — which happens
      // whenever the page is not considered visible (background tab, embedded
      // preview pane), because rAF is throttled there while timers still fire.
      // The flag then stays set and every future resize is silently dropped.
      // clearTimeout+reassign has no such trap: the latest call always wins.
      var upTimer = 0;
      function scheduleUpsellSync(){
        if (upTimer) clearTimeout(upTimer);
        upTimer = setTimeout(function(){
          upTimer = 0; syncUpsellMediaHeight();
        }, 40);
      }

      syncUpsellMediaHeight();

      // Bind resize ALWAYS — never treat ResizeObserver as sufficient.
      // Verified on this storefront: ResizeObserver exists but never fires,
      // not even the guaranteed initial callback, because a third-party
      // script has stubbed it. The old code only attached this listener when
      // ResizeObserver was ABSENT, so on this store nothing ever re-ran and
      // the bottle stayed frozen at its first-paint height while the copy
      // reflowed around it. Treat RO as a bonus, not the mechanism.
      window.addEventListener('resize', scheduleUpsellSync);
      window.addEventListener('orientationchange', scheduleUpsellSync);
      if (window.ResizeObserver){
        try { new ResizeObserver(scheduleUpsellSync).observe(upCopy); } catch (e) {}
      }

      // The webfont swap changes the copy's height after first paint.
      if (document.fonts && document.fonts.ready){
        document.fonts.ready.then(syncUpsellMediaHeight).catch(function(){});
      }
      // Late reflow catch-all: font swap, lazily-loaded media above the card,
      // and app scripts that inject content after load all move the copy.
      var upDelays = [120, 400, 1200, 2500];
      for (var d = 0; d < upDelays.length; d++) setTimeout(syncUpsellMediaHeight, upDelays[d]);

      // Event-independent backstop. Neither ResizeObserver nor the window
      // 'resize' event can be relied on here: RO is stubbed by a third-party
      // script on this storefront, and some embedded/preview viewports change
      // width without emitting 'resize' at all. Both were verified dead on
      // this page. So poll briefly and cheaply instead of trusting either.
      // syncUpsellMediaHeight early-returns when already within 0.5px, so a
      // steady-state tick is one getBoundingClientRect and nothing else.
      // Self-terminating: 30 ticks x 500ms = 15s, which comfortably covers
      // font swap, lazy media above the card, and late app injection. After
      // that the resize listener handles real user resizes in a real browser.
      var upPolls = 0;
      var upPoll = setInterval(function(){
        syncUpsellMediaHeight();
        if (++upPolls >= 30) clearInterval(upPoll);
      }, 500);
    }

    function syncUpsellState(){
      if (!upBox || !upCb) return;
      upBox.classList.toggle('is-declined', !upCb.checked);
    }
    if (upCb){
      upCb.addEventListener('change', syncUpsellState);
      syncUpsellState();
    }

    function openCartDrawer(){
      // Verified against the live AJ storefront: UpCart V2 exposes
      // upcartRefreshCart and upcartOpenCart as TOP-LEVEL window functions,
      // not as methods on window.upcart. Refresh before opening or the drawer
      // paints its preloaded snapshot and the lines we just added are missing.
      try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
      try {
        if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
        else if (window.upcart && typeof window.upcart.openCart === 'function') window.upcart.openCart();
      } catch (e) {}
      // Theme-native fallbacks, for any theme where UpCart is absent.
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
        document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
      } catch (e) {}
      var trigger = document.querySelector('#upcart-cart-trigger,.upcart-trigger,[data-upcart-open]');
      if (trigger){ try { trigger.click(); } catch (e) {} }
      var dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && typeof dawnDrawer.open === 'function'){ try { dawnDrawer.open(); } catch (e) {} }

      // Verify, then fall back. No drawer after ~1s means there is no drawer.
      setTimeout(function(){
        var opened = document.body.classList.contains('upcartPopupShow') ||
                     document.body.classList.contains('upcart-open') ||
                     !!document.querySelector('cart-drawer.active, .drawer.active, #CartDrawer.active');
        if (!opened) window.location.href = '/cart';
      }, 1000);
    }

    function postItems(items){
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: items})
      }).then(function(r){
        if (!r.ok){
          return r.json().catch(function(){ return {}; }).then(function(b){
            var err = new Error('cart/add failed');
            err.status = r.status;
            err.body = b;
            throw err;
          });
        }
        return r.json();
      });
    }

    // Tell UpCart to keep its hands off this buy box.
    //
    // upcartShouldSkipAddToCart is UpCart's own documented opt-out hook
    // (it ships as `e => false`). CHAIN it rather than replace it: anything
    // originating inside a .mbc section is ours to handle, everything else
    // falls through to whatever UpCart or another section already installed,
    // so no other add-to-cart on the page changes behaviour. Installed once
    // per page, not once per section. This is the belt to the type="button"
    // braces above — either alone is sufficient.
    if (!window.__mbcUpcartHooked){
      window.__mbcUpcartHooked = true;
      var priorSkip = window.upcartShouldSkipAddToCart;
      window.upcartShouldSkipAddToCart = function(ev){
        try {
          var t = ev && (ev.target || ev.srcElement);
          if (t && t.closest && t.closest('.mbc')) return true;
        } catch (e) {}
        try { return typeof priorSkip === 'function' ? priorSkip(ev) : false; }
        catch (e) { return false; }
      };
    }

    // The add itself. Shared by the CTA click and the Enter-key guard.
    function doAddToCart(){
      // No fetch = ancient browser. form.submit() is a real browser POST and
      // fires no submit listeners, so nothing can intercept it either.
      if (typeof window.fetch !== 'function'){ if (form) form.submit(); return; }

      var mainId = idInput && idInput.value;
      if (!mainId){ if (form) form.submit(); return; }

      var mainItem = {id: parseInt(mainId, 10), quantity: qty};
      if (planInput && planInput.value) mainItem.selling_plan = planInput.value;

      var items = [mainItem];
      var addOn = null;
      if (upsellWanted()){
        var upId = parseInt(upBox.getAttribute('data-mbcup-variant'), 10);
        if (upId){
          addOn = {id: upId, quantity: 1};
          // Attribution rides ON the add-on line, never on the cart. It therefore
          // survives exactly as long as the line does: rejected on add, or removed
          // in the drawer, means no property and so no order tag. Hidden from the
          // customer by the leading underscore; still readable by Flow and the API.
          var upSrc = (upBox.getAttribute('data-mbcup-source') || '').trim();
          if (upSrc){ addOn.properties = {'_upsell_source': upSrc}; }
          items.push(addOn);
        }
      }

      if (ctaBtn){ ctaBtn.disabled = true; ctaBtn.style.opacity = '.72'; }
      function release(){ if (ctaBtn){ ctaBtn.disabled = false; ctaBtn.style.opacity = ''; } }

      postItems(items)
        .then(function(){ release(); openCartDrawer(); })
        .catch(function(){
          // The add-on is the fragile line: it is Locksmith-locked and it is
          // oversold. Never let it take the main product down with it.
          if (!addOn){ release(); if (form) form.submit(); return; }
          postItems([mainItem])
            .then(function(){
              release();
              if (upCb) upCb.checked = false;
              openCartDrawer();
            })
            .catch(function(){ release(); if (form) form.submit(); });
        });
    }

    if (ctaBtn){
      ctaBtn.addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        doAddToCart();
      });
    }

    // Enter inside the form still raises a submit even with no submit button.
    // Catch it in the CAPTURE phase so we beat any cart app listening on bubble.
    if (form){
      form.addEventListener('submit', function(ev){
        ev.preventDefault();
        ev.stopImmediatePropagation();
        doAddToCart();
      }, true);
    }

    // Gallery
    var mainBox = root.querySelector('.mbc__main');
    var main = root.querySelector('.mbc__main img');
    var countEl = root.querySelector('[id^="mbc-count-"]');
    var thumbsContainer = root.querySelector('.mbc__thumbs');
    var thumbs = root.querySelectorAll('.mbc__thumb');
    var prev = root.querySelector('[id^="mbc-prev-"]');
    var next = root.querySelector('[id^="mbc-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src){
        // Re-point the intrinsic ratio BEFORE swapping src, so the box resizes
        // in one step instead of holding the previous image's height until the
        // new one decodes. Keeps every image at its true shape, uncropped.
        var tw = thumbs[idx].dataset.w, th = thumbs[idx].dataset.h;
        if (tw && th){ main.setAttribute('width', tw); main.setAttribute('height', th); }
        main.src = src;
      }
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._mbcDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._mbcDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._mbcDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._mbcDragged = false; }, 100);
        } else {
          thumbsContainer._mbcDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._mbcDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
